const tokens = {
  "blurs.sm": {
    "value": "4px",
    "variable": "var(--blurs-sm)"
  },
  "blurs.base": {
    "value": "8px",
    "variable": "var(--blurs-base)"
  },
  "blurs.md": {
    "value": "12px",
    "variable": "var(--blurs-md)"
  },
  "blurs.lg": {
    "value": "16px",
    "variable": "var(--blurs-lg)"
  },
  "blurs.xl": {
    "value": "24px",
    "variable": "var(--blurs-xl)"
  },
  "blurs.2xl": {
    "value": "40px",
    "variable": "var(--blurs-2xl)"
  },
  "blurs.3xl": {
    "value": "64px",
    "variable": "var(--blurs-3xl)"
  },
  "borders.none": {
    "value": "none",
    "variable": "var(--borders-none)"
  },
  "durations.fastest": {
    "value": "50ms",
    "variable": "var(--durations-fastest)"
  },
  "durations.faster": {
    "value": "100ms",
    "variable": "var(--durations-faster)"
  },
  "durations.fast": {
    "value": "150ms",
    "variable": "var(--durations-fast)"
  },
  "durations.normal": {
    "value": "200ms",
    "variable": "var(--durations-normal)"
  },
  "durations.slow": {
    "value": "300ms",
    "variable": "var(--durations-slow)"
  },
  "durations.slower": {
    "value": "400ms",
    "variable": "var(--durations-slower)"
  },
  "durations.slowest": {
    "value": "500ms",
    "variable": "var(--durations-slowest)"
  },
  "easings.pulse": {
    "value": "cubic-bezier(0.4, 0.0, 0.6, 1.0)",
    "variable": "var(--easings-pulse)"
  },
  "easings.default": {
    "value": "cubic-bezier(0.2, 0.0, 0, 1.0)",
    "variable": "var(--easings-default)"
  },
  "easings.emphasized-in": {
    "value": "cubic-bezier(0.05, 0.7, 0.1, 1.0)",
    "variable": "var(--easings-emphasized-in)"
  },
  "easings.emphasized-out": {
    "value": "cubic-bezier(0.3, 0.0, 0.8, 0.15)",
    "variable": "var(--easings-emphasized-out)"
  },
  "fontSizes.2xs": {
    "value": "0.5rem",
    "variable": "var(--font-sizes-2xs)"
  },
  "fontSizes.xs": {
    "value": "0.75rem",
    "variable": "var(--font-sizes-xs)"
  },
  "fontSizes.sm": {
    "value": "0.875rem",
    "variable": "var(--font-sizes-sm)"
  },
  "fontSizes.md": {
    "value": "1rem",
    "variable": "var(--font-sizes-md)"
  },
  "fontSizes.lg": {
    "value": "1.125rem",
    "variable": "var(--font-sizes-lg)"
  },
  "fontSizes.xl": {
    "value": "1.25rem",
    "variable": "var(--font-sizes-xl)"
  },
  "fontSizes.2xl": {
    "value": "1.5rem",
    "variable": "var(--font-sizes-2xl)"
  },
  "fontSizes.3xl": {
    "value": "1.875rem",
    "variable": "var(--font-sizes-3xl)"
  },
  "fontSizes.4xl": {
    "value": "2.25rem",
    "variable": "var(--font-sizes-4xl)"
  },
  "fontSizes.5xl": {
    "value": "3rem",
    "variable": "var(--font-sizes-5xl)"
  },
  "fontSizes.6xl": {
    "value": "3.75rem",
    "variable": "var(--font-sizes-6xl)"
  },
  "fontSizes.7xl": {
    "value": "4.5rem",
    "variable": "var(--font-sizes-7xl)"
  },
  "fontSizes.8xl": {
    "value": "6rem",
    "variable": "var(--font-sizes-8xl)"
  },
  "fontSizes.9xl": {
    "value": "8rem",
    "variable": "var(--font-sizes-9xl)"
  },
  "fontWeights.thin": {
    "value": "100",
    "variable": "var(--font-weights-thin)"
  },
  "fontWeights.extralight": {
    "value": "200",
    "variable": "var(--font-weights-extralight)"
  },
  "fontWeights.light": {
    "value": "300",
    "variable": "var(--font-weights-light)"
  },
  "fontWeights.normal": {
    "value": "400",
    "variable": "var(--font-weights-normal)"
  },
  "fontWeights.medium": {
    "value": "500",
    "variable": "var(--font-weights-medium)"
  },
  "fontWeights.semibold": {
    "value": "600",
    "variable": "var(--font-weights-semibold)"
  },
  "fontWeights.bold": {
    "value": "700",
    "variable": "var(--font-weights-bold)"
  },
  "fontWeights.extrabold": {
    "value": "800",
    "variable": "var(--font-weights-extrabold)"
  },
  "fontWeights.black": {
    "value": "900",
    "variable": "var(--font-weights-black)"
  },
  "letterSpacings.tighter": {
    "value": "-0.05em",
    "variable": "var(--letter-spacings-tighter)"
  },
  "letterSpacings.tight": {
    "value": "-0.025em",
    "variable": "var(--letter-spacings-tight)"
  },
  "letterSpacings.normal": {
    "value": "0em",
    "variable": "var(--letter-spacings-normal)"
  },
  "letterSpacings.wide": {
    "value": "0.025em",
    "variable": "var(--letter-spacings-wide)"
  },
  "letterSpacings.wider": {
    "value": "0.05em",
    "variable": "var(--letter-spacings-wider)"
  },
  "letterSpacings.widest": {
    "value": "0.1em",
    "variable": "var(--letter-spacings-widest)"
  },
  "lineHeights.none": {
    "value": "1",
    "variable": "var(--line-heights-none)"
  },
  "lineHeights.tight": {
    "value": "1.25",
    "variable": "var(--line-heights-tight)"
  },
  "lineHeights.normal": {
    "value": "1.5",
    "variable": "var(--line-heights-normal)"
  },
  "lineHeights.relaxed": {
    "value": "1.75",
    "variable": "var(--line-heights-relaxed)"
  },
  "lineHeights.loose": {
    "value": "2",
    "variable": "var(--line-heights-loose)"
  },
  "colors.current": {
    "value": "currentColor",
    "variable": "var(--colors-current)"
  },
  "colors.white": {
    "value": "#ffffff",
    "variable": "var(--colors-white)"
  },
  "colors.white.a1": {
    "value": "rgba(255, 255, 255, 0.05)",
    "variable": "var(--colors-white-a1)"
  },
  "colors.white.a2": {
    "value": "rgba(255, 255, 255, 0.1)",
    "variable": "var(--colors-white-a2)"
  },
  "colors.white.a3": {
    "value": "rgba(255, 255, 255, 0.15)",
    "variable": "var(--colors-white-a3)"
  },
  "colors.white.a4": {
    "value": "rgba(255, 255, 255, 0.2)",
    "variable": "var(--colors-white-a4)"
  },
  "colors.white.a5": {
    "value": "rgba(255, 255, 255, 0.3)",
    "variable": "var(--colors-white-a5)"
  },
  "colors.white.a6": {
    "value": "rgba(255, 255, 255, 0.4)",
    "variable": "var(--colors-white-a6)"
  },
  "colors.white.a7": {
    "value": "rgba(255, 255, 255, 0.5)",
    "variable": "var(--colors-white-a7)"
  },
  "colors.white.a8": {
    "value": "rgba(255, 255, 255, 0.6)",
    "variable": "var(--colors-white-a8)"
  },
  "colors.white.a9": {
    "value": "rgba(255, 255, 255, 0.7)",
    "variable": "var(--colors-white-a9)"
  },
  "colors.white.a10": {
    "value": "rgba(255, 255, 255, 0.8)",
    "variable": "var(--colors-white-a10)"
  },
  "colors.white.a11": {
    "value": "rgba(255, 255, 255, 0.9)",
    "variable": "var(--colors-white-a11)"
  },
  "colors.white.a12": {
    "value": "rgba(255, 255, 255, 0.95)",
    "variable": "var(--colors-white-a12)"
  },
  "colors.transparent": {
    "value": "rgb(0 0 0 / 0)",
    "variable": "var(--colors-transparent)"
  },
  "colors.gray.light.1": {
    "value": "#fcfcfc",
    "variable": "var(--colors-gray-light-1)"
  },
  "colors.gray.light.2": {
    "value": "#f9f9f9",
    "variable": "var(--colors-gray-light-2)"
  },
  "colors.gray.light.3": {
    "value": "#f0f0f0",
    "variable": "var(--colors-gray-light-3)"
  },
  "colors.gray.light.4": {
    "value": "#e8e8e8",
    "variable": "var(--colors-gray-light-4)"
  },
  "colors.gray.light.5": {
    "value": "#e0e0e0",
    "variable": "var(--colors-gray-light-5)"
  },
  "colors.gray.light.6": {
    "value": "#d9d9d9",
    "variable": "var(--colors-gray-light-6)"
  },
  "colors.gray.light.7": {
    "value": "#cecece",
    "variable": "var(--colors-gray-light-7)"
  },
  "colors.gray.light.8": {
    "value": "#bbbbbb",
    "variable": "var(--colors-gray-light-8)"
  },
  "colors.gray.light.9": {
    "value": "#8d8d8d",
    "variable": "var(--colors-gray-light-9)"
  },
  "colors.gray.light.10": {
    "value": "#838383",
    "variable": "var(--colors-gray-light-10)"
  },
  "colors.gray.light.11": {
    "value": "#646464",
    "variable": "var(--colors-gray-light-11)"
  },
  "colors.gray.light.12": {
    "value": "#202020",
    "variable": "var(--colors-gray-light-12)"
  },
  "colors.gray.light.a1": {
    "value": "#00000003",
    "variable": "var(--colors-gray-light-a1)"
  },
  "colors.gray.light.a2": {
    "value": "#00000006",
    "variable": "var(--colors-gray-light-a2)"
  },
  "colors.gray.light.a3": {
    "value": "#0000000f",
    "variable": "var(--colors-gray-light-a3)"
  },
  "colors.gray.light.a4": {
    "value": "#00000017",
    "variable": "var(--colors-gray-light-a4)"
  },
  "colors.gray.light.a5": {
    "value": "#0000001f",
    "variable": "var(--colors-gray-light-a5)"
  },
  "colors.gray.light.a6": {
    "value": "#00000026",
    "variable": "var(--colors-gray-light-a6)"
  },
  "colors.gray.light.a7": {
    "value": "#00000031",
    "variable": "var(--colors-gray-light-a7)"
  },
  "colors.gray.light.a8": {
    "value": "#00000044",
    "variable": "var(--colors-gray-light-a8)"
  },
  "colors.gray.light.a9": {
    "value": "#00000072",
    "variable": "var(--colors-gray-light-a9)"
  },
  "colors.gray.light.a10": {
    "value": "#0000007c",
    "variable": "var(--colors-gray-light-a10)"
  },
  "colors.gray.light.a11": {
    "value": "#0000009b",
    "variable": "var(--colors-gray-light-a11)"
  },
  "colors.gray.light.a12": {
    "value": "#000000df",
    "variable": "var(--colors-gray-light-a12)"
  },
  "colors.gray.dark.1": {
    "value": "#111111",
    "variable": "var(--colors-gray-dark-1)"
  },
  "colors.gray.dark.2": {
    "value": "#191919",
    "variable": "var(--colors-gray-dark-2)"
  },
  "colors.gray.dark.3": {
    "value": "#222222",
    "variable": "var(--colors-gray-dark-3)"
  },
  "colors.gray.dark.4": {
    "value": "#2a2a2a",
    "variable": "var(--colors-gray-dark-4)"
  },
  "colors.gray.dark.5": {
    "value": "#313131",
    "variable": "var(--colors-gray-dark-5)"
  },
  "colors.gray.dark.6": {
    "value": "#3a3a3a",
    "variable": "var(--colors-gray-dark-6)"
  },
  "colors.gray.dark.7": {
    "value": "#484848",
    "variable": "var(--colors-gray-dark-7)"
  },
  "colors.gray.dark.8": {
    "value": "#606060",
    "variable": "var(--colors-gray-dark-8)"
  },
  "colors.gray.dark.9": {
    "value": "#6e6e6e",
    "variable": "var(--colors-gray-dark-9)"
  },
  "colors.gray.dark.10": {
    "value": "#7b7b7b",
    "variable": "var(--colors-gray-dark-10)"
  },
  "colors.gray.dark.11": {
    "value": "#b4b4b4",
    "variable": "var(--colors-gray-dark-11)"
  },
  "colors.gray.dark.12": {
    "value": "#eeeeee",
    "variable": "var(--colors-gray-dark-12)"
  },
  "colors.gray.dark.a1": {
    "value": "#00000000",
    "variable": "var(--colors-gray-dark-a1)"
  },
  "colors.gray.dark.a2": {
    "value": "#ffffff09",
    "variable": "var(--colors-gray-dark-a2)"
  },
  "colors.gray.dark.a3": {
    "value": "#ffffff12",
    "variable": "var(--colors-gray-dark-a3)"
  },
  "colors.gray.dark.a4": {
    "value": "#ffffff1b",
    "variable": "var(--colors-gray-dark-a4)"
  },
  "colors.gray.dark.a5": {
    "value": "#ffffff22",
    "variable": "var(--colors-gray-dark-a5)"
  },
  "colors.gray.dark.a6": {
    "value": "#ffffff2c",
    "variable": "var(--colors-gray-dark-a6)"
  },
  "colors.gray.dark.a7": {
    "value": "#ffffff3b",
    "variable": "var(--colors-gray-dark-a7)"
  },
  "colors.gray.dark.a8": {
    "value": "#ffffff55",
    "variable": "var(--colors-gray-dark-a8)"
  },
  "colors.gray.dark.a9": {
    "value": "#ffffff64",
    "variable": "var(--colors-gray-dark-a9)"
  },
  "colors.gray.dark.a10": {
    "value": "#ffffff72",
    "variable": "var(--colors-gray-dark-a10)"
  },
  "colors.gray.dark.a11": {
    "value": "#ffffffaf",
    "variable": "var(--colors-gray-dark-a11)"
  },
  "colors.gray.dark.a12": {
    "value": "#ffffffed",
    "variable": "var(--colors-gray-dark-a12)"
  },
  "colors.red.light.1": {
    "value": "#fffcfc",
    "variable": "var(--colors-red-light-1)"
  },
  "colors.red.light.2": {
    "value": "#fff7f7",
    "variable": "var(--colors-red-light-2)"
  },
  "colors.red.light.3": {
    "value": "#feebec",
    "variable": "var(--colors-red-light-3)"
  },
  "colors.red.light.4": {
    "value": "#ffdbdc",
    "variable": "var(--colors-red-light-4)"
  },
  "colors.red.light.5": {
    "value": "#ffcdce",
    "variable": "var(--colors-red-light-5)"
  },
  "colors.red.light.6": {
    "value": "#fdbdbe",
    "variable": "var(--colors-red-light-6)"
  },
  "colors.red.light.7": {
    "value": "#f4a9aa",
    "variable": "var(--colors-red-light-7)"
  },
  "colors.red.light.8": {
    "value": "#eb8e90",
    "variable": "var(--colors-red-light-8)"
  },
  "colors.red.light.9": {
    "value": "#e5484d",
    "variable": "var(--colors-red-light-9)"
  },
  "colors.red.light.10": {
    "value": "#dc3e42",
    "variable": "var(--colors-red-light-10)"
  },
  "colors.red.light.11": {
    "value": "#ce2c31",
    "variable": "var(--colors-red-light-11)"
  },
  "colors.red.light.12": {
    "value": "#641723",
    "variable": "var(--colors-red-light-12)"
  },
  "colors.red.light.a1": {
    "value": "#ff000003",
    "variable": "var(--colors-red-light-a1)"
  },
  "colors.red.light.a2": {
    "value": "#ff000008",
    "variable": "var(--colors-red-light-a2)"
  },
  "colors.red.light.a3": {
    "value": "#f3000d14",
    "variable": "var(--colors-red-light-a3)"
  },
  "colors.red.light.a4": {
    "value": "#ff000824",
    "variable": "var(--colors-red-light-a4)"
  },
  "colors.red.light.a5": {
    "value": "#ff000632",
    "variable": "var(--colors-red-light-a5)"
  },
  "colors.red.light.a6": {
    "value": "#f8000442",
    "variable": "var(--colors-red-light-a6)"
  },
  "colors.red.light.a7": {
    "value": "#df000356",
    "variable": "var(--colors-red-light-a7)"
  },
  "colors.red.light.a8": {
    "value": "#d2000571",
    "variable": "var(--colors-red-light-a8)"
  },
  "colors.red.light.a9": {
    "value": "#db0007b7",
    "variable": "var(--colors-red-light-a9)"
  },
  "colors.red.light.a10": {
    "value": "#d10005c1",
    "variable": "var(--colors-red-light-a10)"
  },
  "colors.red.light.a11": {
    "value": "#c40006d3",
    "variable": "var(--colors-red-light-a11)"
  },
  "colors.red.light.a12": {
    "value": "#55000de8",
    "variable": "var(--colors-red-light-a12)"
  },
  "colors.red.dark.1": {
    "value": "#191111",
    "variable": "var(--colors-red-dark-1)"
  },
  "colors.red.dark.2": {
    "value": "#201314",
    "variable": "var(--colors-red-dark-2)"
  },
  "colors.red.dark.3": {
    "value": "#3b1219",
    "variable": "var(--colors-red-dark-3)"
  },
  "colors.red.dark.4": {
    "value": "#500f1c",
    "variable": "var(--colors-red-dark-4)"
  },
  "colors.red.dark.5": {
    "value": "#611623",
    "variable": "var(--colors-red-dark-5)"
  },
  "colors.red.dark.6": {
    "value": "#72232d",
    "variable": "var(--colors-red-dark-6)"
  },
  "colors.red.dark.7": {
    "value": "#8c333a",
    "variable": "var(--colors-red-dark-7)"
  },
  "colors.red.dark.8": {
    "value": "#b54548",
    "variable": "var(--colors-red-dark-8)"
  },
  "colors.red.dark.9": {
    "value": "#e5484d",
    "variable": "var(--colors-red-dark-9)"
  },
  "colors.red.dark.10": {
    "value": "#ec5d5e",
    "variable": "var(--colors-red-dark-10)"
  },
  "colors.red.dark.11": {
    "value": "#ff9592",
    "variable": "var(--colors-red-dark-11)"
  },
  "colors.red.dark.12": {
    "value": "#ffd1d9",
    "variable": "var(--colors-red-dark-12)"
  },
  "colors.red.dark.a1": {
    "value": "#f4121209",
    "variable": "var(--colors-red-dark-a1)"
  },
  "colors.red.dark.a2": {
    "value": "#f22f3e11",
    "variable": "var(--colors-red-dark-a2)"
  },
  "colors.red.dark.a3": {
    "value": "#ff173f2d",
    "variable": "var(--colors-red-dark-a3)"
  },
  "colors.red.dark.a4": {
    "value": "#fe0a3b44",
    "variable": "var(--colors-red-dark-a4)"
  },
  "colors.red.dark.a5": {
    "value": "#ff204756",
    "variable": "var(--colors-red-dark-a5)"
  },
  "colors.red.dark.a6": {
    "value": "#ff3e5668",
    "variable": "var(--colors-red-dark-a6)"
  },
  "colors.red.dark.a7": {
    "value": "#ff536184",
    "variable": "var(--colors-red-dark-a7)"
  },
  "colors.red.dark.a8": {
    "value": "#ff5d61b0",
    "variable": "var(--colors-red-dark-a8)"
  },
  "colors.red.dark.a9": {
    "value": "#fe4e54e4",
    "variable": "var(--colors-red-dark-a9)"
  },
  "colors.red.dark.a10": {
    "value": "#ff6465eb",
    "variable": "var(--colors-red-dark-a10)"
  },
  "colors.red.dark.a11": {
    "value": "#ff9592",
    "variable": "var(--colors-red-dark-a11)"
  },
  "colors.red.dark.a12": {
    "value": "#ffd1d9",
    "variable": "var(--colors-red-dark-a12)"
  },
  "colors.neutral.light.1": {
    "value": "#fcfcfc",
    "variable": "var(--colors-neutral-light-1)"
  },
  "colors.neutral.light.2": {
    "value": "#f9f9f9",
    "variable": "var(--colors-neutral-light-2)"
  },
  "colors.neutral.light.3": {
    "value": "#f0f0f0",
    "variable": "var(--colors-neutral-light-3)"
  },
  "colors.neutral.light.4": {
    "value": "#e8e8e8",
    "variable": "var(--colors-neutral-light-4)"
  },
  "colors.neutral.light.5": {
    "value": "#e0e0e0",
    "variable": "var(--colors-neutral-light-5)"
  },
  "colors.neutral.light.6": {
    "value": "#d9d9d9",
    "variable": "var(--colors-neutral-light-6)"
  },
  "colors.neutral.light.7": {
    "value": "#cecece",
    "variable": "var(--colors-neutral-light-7)"
  },
  "colors.neutral.light.8": {
    "value": "#bbbbbb",
    "variable": "var(--colors-neutral-light-8)"
  },
  "colors.neutral.light.9": {
    "value": "#8d8d8d",
    "variable": "var(--colors-neutral-light-9)"
  },
  "colors.neutral.light.10": {
    "value": "#838383",
    "variable": "var(--colors-neutral-light-10)"
  },
  "colors.neutral.light.11": {
    "value": "#646464",
    "variable": "var(--colors-neutral-light-11)"
  },
  "colors.neutral.light.12": {
    "value": "#202020",
    "variable": "var(--colors-neutral-light-12)"
  },
  "colors.neutral.light.a1": {
    "value": "#00000003",
    "variable": "var(--colors-neutral-light-a1)"
  },
  "colors.neutral.light.a2": {
    "value": "#00000006",
    "variable": "var(--colors-neutral-light-a2)"
  },
  "colors.neutral.light.a3": {
    "value": "#0000000f",
    "variable": "var(--colors-neutral-light-a3)"
  },
  "colors.neutral.light.a4": {
    "value": "#00000017",
    "variable": "var(--colors-neutral-light-a4)"
  },
  "colors.neutral.light.a5": {
    "value": "#0000001f",
    "variable": "var(--colors-neutral-light-a5)"
  },
  "colors.neutral.light.a6": {
    "value": "#00000026",
    "variable": "var(--colors-neutral-light-a6)"
  },
  "colors.neutral.light.a7": {
    "value": "#00000031",
    "variable": "var(--colors-neutral-light-a7)"
  },
  "colors.neutral.light.a8": {
    "value": "#00000044",
    "variable": "var(--colors-neutral-light-a8)"
  },
  "colors.neutral.light.a9": {
    "value": "#00000072",
    "variable": "var(--colors-neutral-light-a9)"
  },
  "colors.neutral.light.a10": {
    "value": "#0000007c",
    "variable": "var(--colors-neutral-light-a10)"
  },
  "colors.neutral.light.a11": {
    "value": "#0000009b",
    "variable": "var(--colors-neutral-light-a11)"
  },
  "colors.neutral.light.a12": {
    "value": "#000000df",
    "variable": "var(--colors-neutral-light-a12)"
  },
  "colors.neutral.dark.1": {
    "value": "#111111",
    "variable": "var(--colors-neutral-dark-1)"
  },
  "colors.neutral.dark.2": {
    "value": "#191919",
    "variable": "var(--colors-neutral-dark-2)"
  },
  "colors.neutral.dark.3": {
    "value": "#222222",
    "variable": "var(--colors-neutral-dark-3)"
  },
  "colors.neutral.dark.4": {
    "value": "#2a2a2a",
    "variable": "var(--colors-neutral-dark-4)"
  },
  "colors.neutral.dark.5": {
    "value": "#313131",
    "variable": "var(--colors-neutral-dark-5)"
  },
  "colors.neutral.dark.6": {
    "value": "#3a3a3a",
    "variable": "var(--colors-neutral-dark-6)"
  },
  "colors.neutral.dark.7": {
    "value": "#484848",
    "variable": "var(--colors-neutral-dark-7)"
  },
  "colors.neutral.dark.8": {
    "value": "#606060",
    "variable": "var(--colors-neutral-dark-8)"
  },
  "colors.neutral.dark.9": {
    "value": "#6e6e6e",
    "variable": "var(--colors-neutral-dark-9)"
  },
  "colors.neutral.dark.10": {
    "value": "#7b7b7b",
    "variable": "var(--colors-neutral-dark-10)"
  },
  "colors.neutral.dark.11": {
    "value": "#b4b4b4",
    "variable": "var(--colors-neutral-dark-11)"
  },
  "colors.neutral.dark.12": {
    "value": "#eeeeee",
    "variable": "var(--colors-neutral-dark-12)"
  },
  "colors.neutral.dark.a1": {
    "value": "#00000000",
    "variable": "var(--colors-neutral-dark-a1)"
  },
  "colors.neutral.dark.a2": {
    "value": "#ffffff09",
    "variable": "var(--colors-neutral-dark-a2)"
  },
  "colors.neutral.dark.a3": {
    "value": "#ffffff12",
    "variable": "var(--colors-neutral-dark-a3)"
  },
  "colors.neutral.dark.a4": {
    "value": "#ffffff1b",
    "variable": "var(--colors-neutral-dark-a4)"
  },
  "colors.neutral.dark.a5": {
    "value": "#ffffff22",
    "variable": "var(--colors-neutral-dark-a5)"
  },
  "colors.neutral.dark.a6": {
    "value": "#ffffff2c",
    "variable": "var(--colors-neutral-dark-a6)"
  },
  "colors.neutral.dark.a7": {
    "value": "#ffffff3b",
    "variable": "var(--colors-neutral-dark-a7)"
  },
  "colors.neutral.dark.a8": {
    "value": "#ffffff55",
    "variable": "var(--colors-neutral-dark-a8)"
  },
  "colors.neutral.dark.a9": {
    "value": "#ffffff64",
    "variable": "var(--colors-neutral-dark-a9)"
  },
  "colors.neutral.dark.a10": {
    "value": "#ffffff72",
    "variable": "var(--colors-neutral-dark-a10)"
  },
  "colors.neutral.dark.a11": {
    "value": "#ffffffaf",
    "variable": "var(--colors-neutral-dark-a11)"
  },
  "colors.neutral.dark.a12": {
    "value": "#ffffffed",
    "variable": "var(--colors-neutral-dark-a12)"
  },
  "colors.primary.primary": {
    "value": "#C7F50D",
    "variable": "var(--colors-primary-primary)"
  },
  "colors.primary.orangeDarker": {
    "value": "#4d5f04",
    "variable": "var(--colors-primary-orange-darker)"
  },
  "colors.primary.orangeDark": {
    "value": "#a5cc0b",
    "variable": "var(--colors-primary-orange-dark)"
  },
  "colors.primary.orange": {
    "value": "#C7F50D",
    "variable": "var(--colors-primary-orange)"
  },
  "colors.primary.orangeLight": {
    "value": "#D6FF2E",
    "variable": "var(--colors-primary-orange-light)"
  },
  "colors.primary.orangeLighter": {
    "value": "#D6FF2E",
    "variable": "var(--colors-primary-orange-lighter)"
  },
  "colors.black": {
    "value": "#000000",
    "variable": "var(--colors-black)"
  },
  "colors.black.a1": {
    "value": "rgba(0, 0, 0, 0.05)",
    "variable": "var(--colors-black-a1)"
  },
  "colors.black.a2": {
    "value": "rgba(0, 0, 0, 0.1)",
    "variable": "var(--colors-black-a2)"
  },
  "colors.black.a3": {
    "value": "rgba(0, 0, 0, 0.15)",
    "variable": "var(--colors-black-a3)"
  },
  "colors.black.a4": {
    "value": "rgba(0, 0, 0, 0.2)",
    "variable": "var(--colors-black-a4)"
  },
  "colors.black.a5": {
    "value": "rgba(0, 0, 0, 0.3)",
    "variable": "var(--colors-black-a5)"
  },
  "colors.black.a6": {
    "value": "rgba(0, 0, 0, 0.4)",
    "variable": "var(--colors-black-a6)"
  },
  "colors.black.a7": {
    "value": "rgba(0, 0, 0, 0.5)",
    "variable": "var(--colors-black-a7)"
  },
  "colors.black.a8": {
    "value": "rgba(0, 0, 0, 0.6)",
    "variable": "var(--colors-black-a8)"
  },
  "colors.black.a9": {
    "value": "rgba(0, 0, 0, 0.7)",
    "variable": "var(--colors-black-a9)"
  },
  "colors.black.a10": {
    "value": "rgba(0, 0, 0, 0.8)",
    "variable": "var(--colors-black-a10)"
  },
  "colors.black.a11": {
    "value": "rgba(0, 0, 0, 0.9)",
    "variable": "var(--colors-black-a11)"
  },
  "colors.black.a12": {
    "value": "rgba(0, 0, 0, 0.95)",
    "variable": "var(--colors-black-a12)"
  },
  "colors.black.fullBlack": {
    "value": "#0a0b0a",
    "variable": "var(--colors-black-full-black)"
  },
  "colors.black.background": {
    "value": "#0f110f",
    "variable": "var(--colors-black-background)"
  },
  "colors.black.lightBlack": {
    "value": "#262c26",
    "variable": "var(--colors-black-light-black)"
  },
  "colors.black.lighterBlack": {
    "value": "#1a1e1a",
    "variable": "var(--colors-black-lighter-black)"
  },
  "colors.black.lv1": {
    "value": "#131613",
    "variable": "var(--colors-black-lv1)"
  },
  "colors.black.lv2": {
    "value": "#1a1e1a",
    "variable": "var(--colors-black-lv2)"
  },
  "colors.black.lv3": {
    "value": "#212621",
    "variable": "var(--colors-black-lv3)"
  },
  "colors.black.lv4": {
    "value": "#262c26",
    "variable": "var(--colors-black-lv4)"
  },
  "colors.black.lv5": {
    "value": "#2b322b",
    "variable": "var(--colors-black-lv5)"
  },
  "colors.black.lv6": {
    "value": "#3d443d",
    "variable": "var(--colors-black-lv6)"
  },
  "colors.greyWhite.outline": {
    "value": "#272b27",
    "variable": "var(--colors-grey-white-outline)"
  },
  "colors.greyWhite.darkGary1": {
    "value": "#1a1e1a",
    "variable": "var(--colors-grey-white-dark-gary1)"
  },
  "colors.greyWhite.darkGary2": {
    "value": "#2b322b",
    "variable": "var(--colors-grey-white-dark-gary2)"
  },
  "colors.greyWhite.darkGary3": {
    "value": "#272b27",
    "variable": "var(--colors-grey-white-dark-gary3)"
  },
  "colors.greyWhite.darkGary4": {
    "value": "#212621",
    "variable": "var(--colors-grey-white-dark-gary4)"
  },
  "colors.greyWhite.lightGrey3": {
    "value": "#9ba294",
    "variable": "var(--colors-grey-white-light-grey3)"
  },
  "colors.greyWhite.lightGrey2": {
    "value": "#c9cec4",
    "variable": "var(--colors-grey-white-light-grey2)"
  },
  "colors.greyWhite.lightGrey1": {
    "value": "#f5f7f2",
    "variable": "var(--colors-grey-white-light-grey1)"
  },
  "colors.greyWhite.lightGrey4": {
    "value": "#6f766a",
    "variable": "var(--colors-grey-white-light-grey4)"
  },
  "colors.greyWhite.white": {
    "value": "#FFFFFF",
    "variable": "var(--colors-grey-white-white)"
  },
  "colors.price.priceUp": {
    "value": "#c7f50d",
    "variable": "var(--colors-price-price-up)"
  },
  "colors.price.priceUpEmphasized": {
    "value": "#d6ff2e",
    "variable": "var(--colors-price-price-up-emphasized)"
  },
  "colors.price.priceDown": {
    "value": "#FA5000",
    "variable": "var(--colors-price-price-down)"
  },
  "colors.price.priceDownEmphasized": {
    "value": "#ff6a24",
    "variable": "var(--colors-price-price-down-emphasized)"
  },
  "colors.price.priceUpBg": {
    "value": "rgba(199, 245, 13, 0.12)",
    "variable": "var(--colors-price-price-up-bg)"
  },
  "colors.price.priceDownBg": {
    "value": "rgba(250, 80, 0, 0.12)",
    "variable": "var(--colors-price-price-down-bg)"
  },
  "colors.price.priceUpLight": {
    "value": "rgba(199, 245, 13, 0.12)",
    "variable": "var(--colors-price-price-up-light)"
  },
  "colors.price.priceDownLight": {
    "value": "rgba(250, 80, 0, 0.12)",
    "variable": "var(--colors-price-price-down-light)"
  },
  "colors.system.errorLight": {
    "value": "#ff6a24",
    "variable": "var(--colors-system-error-light)"
  },
  "colors.system.error": {
    "value": "#FA5000",
    "variable": "var(--colors-system-error)"
  },
  "colors.system.errorDark": {
    "value": "#7c2b06",
    "variable": "var(--colors-system-error-dark)"
  },
  "colors.system.successLight": {
    "value": "#D6FF2E",
    "variable": "var(--colors-system-success-light)"
  },
  "colors.system.success": {
    "value": "#C7F50D",
    "variable": "var(--colors-system-success)"
  },
  "colors.system.successDark": {
    "value": "#4d5f04",
    "variable": "var(--colors-system-success-dark)"
  },
  "colors.system.systemLight": {
    "value": "#9CC7FF",
    "variable": "var(--colors-system-system-light)"
  },
  "colors.system.system": {
    "value": "#4e9cf5",
    "variable": "var(--colors-system-system)"
  },
  "colors.system.systemDark": {
    "value": "#2750AE",
    "variable": "var(--colors-system-system-dark)"
  },
  "colors.v2.bg.canvas": {
    "value": "#0a0b0a",
    "variable": "var(--colors-v2-bg-canvas)"
  },
  "colors.v2.bg.app": {
    "value": "#0f110f",
    "variable": "var(--colors-v2-bg-app)"
  },
  "colors.v2.bg.panel": {
    "value": "#131613",
    "variable": "var(--colors-v2-bg-panel)"
  },
  "colors.v2.bg.surface1": {
    "value": "#1a1e1a",
    "variable": "var(--colors-v2-bg-surface1)"
  },
  "colors.v2.bg.surface2": {
    "value": "#212621",
    "variable": "var(--colors-v2-bg-surface2)"
  },
  "colors.v2.bg.surface3": {
    "value": "#262c26",
    "variable": "var(--colors-v2-bg-surface3)"
  },
  "colors.v2.bg.hover": {
    "value": "#2b322b",
    "variable": "var(--colors-v2-bg-hover)"
  },
  "colors.v2.border.hairline": {
    "value": "rgba(255, 255, 255, 0.06)",
    "variable": "var(--colors-v2-border-hairline)"
  },
  "colors.v2.border.default": {
    "value": "#272b27",
    "variable": "var(--colors-v2-border-default)"
  },
  "colors.v2.border.strong": {
    "value": "#3d443d",
    "variable": "var(--colors-v2-border-strong)"
  },
  "colors.v2.border.focus": {
    "value": "rgba(199, 245, 13, 0.55)",
    "variable": "var(--colors-v2-border-focus)"
  },
  "colors.v2.text.primary": {
    "value": "#f5f7f2",
    "variable": "var(--colors-v2-text-primary)"
  },
  "colors.v2.text.secondary": {
    "value": "#c9cec4",
    "variable": "var(--colors-v2-text-secondary)"
  },
  "colors.v2.text.muted": {
    "value": "#9ba294",
    "variable": "var(--colors-v2-text-muted)"
  },
  "colors.v2.text.subtle": {
    "value": "#6f766a",
    "variable": "var(--colors-v2-text-subtle)"
  },
  "colors.v2.text.disabled": {
    "value": "#4d534a",
    "variable": "var(--colors-v2-text-disabled)"
  },
  "colors.v2.text.onAccent": {
    "value": "#0a0b0a",
    "variable": "var(--colors-v2-text-on-accent)"
  },
  "colors.v2.long.default": {
    "value": "#c7f50d",
    "variable": "var(--colors-v2-long-default)"
  },
  "colors.v2.long.strong": {
    "value": "#d6ff2e",
    "variable": "var(--colors-v2-long-strong)"
  },
  "colors.v2.long.dim": {
    "value": "rgba(199, 245, 13, 0.12)",
    "variable": "var(--colors-v2-long-dim)"
  },
  "colors.v2.long.border": {
    "value": "rgba(199, 245, 13, 0.35)",
    "variable": "var(--colors-v2-long-border)"
  },
  "colors.v2.long.deep": {
    "value": "#4d5f04",
    "variable": "var(--colors-v2-long-deep)"
  },
  "colors.v2.short.default": {
    "value": "#fa5000",
    "variable": "var(--colors-v2-short-default)"
  },
  "colors.v2.short.strong": {
    "value": "#ff6a24",
    "variable": "var(--colors-v2-short-strong)"
  },
  "colors.v2.short.dim": {
    "value": "rgba(250, 80, 0, 0.12)",
    "variable": "var(--colors-v2-short-dim)"
  },
  "colors.v2.short.border": {
    "value": "rgba(250, 80, 0, 0.38)",
    "variable": "var(--colors-v2-short-border)"
  },
  "colors.v2.short.deep": {
    "value": "#7c2b06",
    "variable": "var(--colors-v2-short-deep)"
  },
  "colors.v2.info": {
    "value": "#4e9cf5",
    "variable": "var(--colors-v2-info)"
  },
  "colors.v2.warning": {
    "value": "#f5c518",
    "variable": "var(--colors-v2-warning)"
  },
  "colors.v2.warningDim": {
    "value": "rgba(245, 197, 24, 0.08)",
    "variable": "var(--colors-v2-warning-dim)"
  },
  "colors.v2.warningBorder": {
    "value": "rgba(245, 197, 24, 0.35)",
    "variable": "var(--colors-v2-warning-border)"
  },
  "colors.v2.tokLv": {
    "value": "#c7f50d",
    "variable": "var(--colors-v2-tok-lv)"
  },
  "colors.v2.tokLvusd": {
    "value": "#2fbf6b",
    "variable": "var(--colors-v2-tok-lvusd)"
  },
  "colors.v2.tokLvmon": {
    "value": "#8b7bf0",
    "variable": "var(--colors-v2-tok-lvmon)"
  },
  "colors.v2.vipGold": {
    "value": "#e8c15a",
    "variable": "var(--colors-v2-vip-gold)"
  },
  "colors.v2.vipGoldDim": {
    "value": "rgba(232, 193, 90, 0.08)",
    "variable": "var(--colors-v2-vip-gold-dim)"
  },
  "colors.v2.vipGoldBorder": {
    "value": "rgba(232, 193, 90, 0.35)",
    "variable": "var(--colors-v2-vip-gold-border)"
  },
  "colors.v2.gridLine": {
    "value": "rgba(255, 255, 255, 0.045)",
    "variable": "var(--colors-v2-grid-line)"
  },
  "colors.gradients.G.01": {
    "value": "linear-gradient(153.13deg, #373E44 0.01%, #191B1F 99.69%)",
    "variable": "var(--colors-gradients--g-01)"
  },
  "colors.gradients.G.leaderBoardGradient": {
    "value": "linear-gradient(180deg, #DCEFFF 3.07%, #D9D9D9 100%)",
    "variable": "var(--colors-gradients--g-leader-board-gradient)"
  },
  "colors.gradients.unCategorized.green": {
    "value": "linear-gradient(272deg, rgba(30, 168, 101, 0.20) 0%, #181818 100%), #151E21",
    "variable": "var(--colors-gradients-un-categorized-green)"
  },
  "colors.other.tooltip": {
    "value": "#212621",
    "variable": "var(--colors-other-tooltip)"
  },
  "colors.other.banner": {
    "value": "#131613",
    "variable": "var(--colors-other-banner)"
  },
  "fonts.sans": {
    "value": "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
    "variable": "var(--fonts-sans)"
  },
  "fonts.serif": {
    "value": "ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
    "variable": "var(--fonts-serif)"
  },
  "fonts.mono": {
    "value": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace",
    "variable": "var(--fonts-mono)"
  },
  "fonts.Inter": {
    "value": "var(--font-inter)",
    "variable": "var(--fonts--inter)"
  },
  "fonts.Orbitron": {
    "value": "var(--font-orbitron)",
    "variable": "var(--fonts--orbitron)"
  },
  "fonts.Mono": {
    "value": "var(--font-plex-mono)",
    "variable": "var(--fonts--mono)"
  },
  "fonts.Righteous": {
    "value": "var(--font-righteous)",
    "variable": "var(--fonts--righteous)"
  },
  "spacing.0": {
    "value": "0rem",
    "variable": "var(--spacing-0)"
  },
  "spacing.1": {
    "value": "0.25rem",
    "variable": "var(--spacing-1)"
  },
  "spacing.2": {
    "value": "0.5rem",
    "variable": "var(--spacing-2)"
  },
  "spacing.3": {
    "value": "0.75rem",
    "variable": "var(--spacing-3)"
  },
  "spacing.4": {
    "value": "1rem",
    "variable": "var(--spacing-4)"
  },
  "spacing.5": {
    "value": "1.25rem",
    "variable": "var(--spacing-5)"
  },
  "spacing.6": {
    "value": "1.5rem",
    "variable": "var(--spacing-6)"
  },
  "spacing.7": {
    "value": "1.75rem",
    "variable": "var(--spacing-7)"
  },
  "spacing.8": {
    "value": "2rem",
    "variable": "var(--spacing-8)"
  },
  "spacing.9": {
    "value": "2.25rem",
    "variable": "var(--spacing-9)"
  },
  "spacing.10": {
    "value": "2.5rem",
    "variable": "var(--spacing-10)"
  },
  "spacing.11": {
    "value": "2.75rem",
    "variable": "var(--spacing-11)"
  },
  "spacing.12": {
    "value": "3rem",
    "variable": "var(--spacing-12)"
  },
  "spacing.14": {
    "value": "3.5rem",
    "variable": "var(--spacing-14)"
  },
  "spacing.16": {
    "value": "4rem",
    "variable": "var(--spacing-16)"
  },
  "spacing.20": {
    "value": "5rem",
    "variable": "var(--spacing-20)"
  },
  "spacing.24": {
    "value": "6rem",
    "variable": "var(--spacing-24)"
  },
  "spacing.28": {
    "value": "7rem",
    "variable": "var(--spacing-28)"
  },
  "spacing.32": {
    "value": "8rem",
    "variable": "var(--spacing-32)"
  },
  "spacing.36": {
    "value": "9rem",
    "variable": "var(--spacing-36)"
  },
  "spacing.40": {
    "value": "10rem",
    "variable": "var(--spacing-40)"
  },
  "spacing.44": {
    "value": "11rem",
    "variable": "var(--spacing-44)"
  },
  "spacing.48": {
    "value": "12rem",
    "variable": "var(--spacing-48)"
  },
  "spacing.52": {
    "value": "13rem",
    "variable": "var(--spacing-52)"
  },
  "spacing.56": {
    "value": "14rem",
    "variable": "var(--spacing-56)"
  },
  "spacing.60": {
    "value": "15rem",
    "variable": "var(--spacing-60)"
  },
  "spacing.64": {
    "value": "16rem",
    "variable": "var(--spacing-64)"
  },
  "spacing.72": {
    "value": "18rem",
    "variable": "var(--spacing-72)"
  },
  "spacing.80": {
    "value": "20rem",
    "variable": "var(--spacing-80)"
  },
  "spacing.96": {
    "value": "24rem",
    "variable": "var(--spacing-96)"
  },
  "spacing.0.5": {
    "value": "0.125rem",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.1.5": {
    "value": "0.375rem",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.2.5": {
    "value": "0.625rem",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.3.5": {
    "value": "0.875rem",
    "variable": "var(--spacing-3\\.5)"
  },
  "spacing.4.5": {
    "value": "1.125rem",
    "variable": "var(--spacing-4\\.5)"
  },
  "spacing.layout.topNavBarHeight": {
    "value": "48px",
    "variable": "var(--spacing-layout-top-nav-bar-height)"
  },
  "spacing.layout.announcementHeight": {
    "value": "70px",
    "variable": "var(--spacing-layout-announcement-height)"
  },
  "spacing.layout.pairInfoBarHeight": {
    "value": "56px",
    "variable": "var(--spacing-layout-pair-info-bar-height)"
  },
  "spacing.layout.topNavBarWithAnnouncementHeight": {
    "value": "118px",
    "variable": "var(--spacing-layout-top-nav-bar-with-announcement-height)"
  },
  "spacing.layout.contentHeight": {
    "value": "calc(100vh - 104px)",
    "variable": "var(--spacing-layout-content-height)"
  },
  "spacing.layout.contentHeightWithAnnouncement": {
    "value": "calc(100vh - 174px)",
    "variable": "var(--spacing-layout-content-height-with-announcement)"
  },
  "spacing.layout.bottomNavHeight": {
    "value": "56px",
    "variable": "var(--spacing-layout-bottom-nav-height)"
  },
  "spacing.layout.earnClaimBannerHeight": {
    "value": "56px",
    "variable": "var(--spacing-layout-earn-claim-banner-height)"
  },
  "spacing.leverup.0": {
    "value": "0px",
    "variable": "var(--spacing-leverup-0)"
  },
  "spacing.leverup.1": {
    "value": "4px",
    "variable": "var(--spacing-leverup-1)"
  },
  "spacing.leverup.2": {
    "value": "8px",
    "variable": "var(--spacing-leverup-2)"
  },
  "spacing.leverup.3": {
    "value": "16px",
    "variable": "var(--spacing-leverup-3)"
  },
  "spacing.leverup.4": {
    "value": "32px",
    "variable": "var(--spacing-leverup-4)"
  },
  "spacing.leverup.5": {
    "value": "64px",
    "variable": "var(--spacing-leverup-5)"
  },
  "spacing.leverup.6": {
    "value": "128px",
    "variable": "var(--spacing-leverup-6)"
  },
  "spacing.leverup.7": {
    "value": "256px",
    "variable": "var(--spacing-leverup-7)"
  },
  "spacing.leverup.8": {
    "value": "512px",
    "variable": "var(--spacing-leverup-8)"
  },
  "spacing.leverup.3.5": {
    "value": "24px",
    "variable": "var(--spacing-leverup-3\\.5)"
  },
  "spacing.leverup.4.5": {
    "value": "40px",
    "variable": "var(--spacing-leverup-4\\.5)"
  },
  "radii.none": {
    "value": "0",
    "variable": "var(--radii-none)"
  },
  "radii.2xs": {
    "value": "0.0625rem",
    "variable": "var(--radii-2xs)"
  },
  "radii.xs": {
    "value": "0.125rem",
    "variable": "var(--radii-xs)"
  },
  "radii.sm": {
    "value": "0.25rem",
    "variable": "var(--radii-sm)"
  },
  "radii.md": {
    "value": "0.375rem",
    "variable": "var(--radii-md)"
  },
  "radii.lg": {
    "value": "0.5rem",
    "variable": "var(--radii-lg)"
  },
  "radii.xl": {
    "value": "0.75rem",
    "variable": "var(--radii-xl)"
  },
  "radii.2xl": {
    "value": "1rem",
    "variable": "var(--radii-2xl)"
  },
  "radii.3xl": {
    "value": "1.5rem",
    "variable": "var(--radii-3xl)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--radii-full)"
  },
  "sizes.0": {
    "value": "0rem",
    "variable": "var(--sizes-0)"
  },
  "sizes.1": {
    "value": "0.25rem",
    "variable": "var(--sizes-1)"
  },
  "sizes.2": {
    "value": "0.5rem",
    "variable": "var(--sizes-2)"
  },
  "sizes.3": {
    "value": "0.75rem",
    "variable": "var(--sizes-3)"
  },
  "sizes.4": {
    "value": "1rem",
    "variable": "var(--sizes-4)"
  },
  "sizes.5": {
    "value": "1.25rem",
    "variable": "var(--sizes-5)"
  },
  "sizes.6": {
    "value": "1.5rem",
    "variable": "var(--sizes-6)"
  },
  "sizes.7": {
    "value": "1.75rem",
    "variable": "var(--sizes-7)"
  },
  "sizes.8": {
    "value": "2rem",
    "variable": "var(--sizes-8)"
  },
  "sizes.9": {
    "value": "2.25rem",
    "variable": "var(--sizes-9)"
  },
  "sizes.10": {
    "value": "2.5rem",
    "variable": "var(--sizes-10)"
  },
  "sizes.11": {
    "value": "2.75rem",
    "variable": "var(--sizes-11)"
  },
  "sizes.12": {
    "value": "3rem",
    "variable": "var(--sizes-12)"
  },
  "sizes.13": {
    "value": "52px",
    "variable": "var(--sizes-13)"
  },
  "sizes.14": {
    "value": "3.5rem",
    "variable": "var(--sizes-14)"
  },
  "sizes.16": {
    "value": "4rem",
    "variable": "var(--sizes-16)"
  },
  "sizes.20": {
    "value": "6.25rem",
    "variable": "var(--sizes-20)"
  },
  "sizes.24": {
    "value": "6rem",
    "variable": "var(--sizes-24)"
  },
  "sizes.28": {
    "value": "7rem",
    "variable": "var(--sizes-28)"
  },
  "sizes.32": {
    "value": "8rem",
    "variable": "var(--sizes-32)"
  },
  "sizes.36": {
    "value": "9rem",
    "variable": "var(--sizes-36)"
  },
  "sizes.40": {
    "value": "10rem",
    "variable": "var(--sizes-40)"
  },
  "sizes.44": {
    "value": "11rem",
    "variable": "var(--sizes-44)"
  },
  "sizes.48": {
    "value": "12rem",
    "variable": "var(--sizes-48)"
  },
  "sizes.52": {
    "value": "13rem",
    "variable": "var(--sizes-52)"
  },
  "sizes.56": {
    "value": "14rem",
    "variable": "var(--sizes-56)"
  },
  "sizes.60": {
    "value": "15rem",
    "variable": "var(--sizes-60)"
  },
  "sizes.64": {
    "value": "16rem",
    "variable": "var(--sizes-64)"
  },
  "sizes.72": {
    "value": "18rem",
    "variable": "var(--sizes-72)"
  },
  "sizes.80": {
    "value": "20rem",
    "variable": "var(--sizes-80)"
  },
  "sizes.96": {
    "value": "24rem",
    "variable": "var(--sizes-96)"
  },
  "sizes.0.5": {
    "value": "0.125rem",
    "variable": "var(--sizes-0\\.5)"
  },
  "sizes.1.5": {
    "value": "0.375rem",
    "variable": "var(--sizes-1\\.5)"
  },
  "sizes.2.5": {
    "value": "0.625rem",
    "variable": "var(--sizes-2\\.5)"
  },
  "sizes.3.5": {
    "value": "0.875rem",
    "variable": "var(--sizes-3\\.5)"
  },
  "sizes.4.5": {
    "value": "1.125rem",
    "variable": "var(--sizes-4\\.5)"
  },
  "sizes.layout.topNavBarHeight": {
    "value": "48px",
    "variable": "var(--sizes-layout-top-nav-bar-height)"
  },
  "sizes.layout.announcementHeight": {
    "value": "70px",
    "variable": "var(--sizes-layout-announcement-height)"
  },
  "sizes.layout.pairInfoBarHeight": {
    "value": "56px",
    "variable": "var(--sizes-layout-pair-info-bar-height)"
  },
  "sizes.layout.topNavBarWithAnnouncementHeight": {
    "value": "118px",
    "variable": "var(--sizes-layout-top-nav-bar-with-announcement-height)"
  },
  "sizes.layout.contentHeight": {
    "value": "calc(100vh - 104px)",
    "variable": "var(--sizes-layout-content-height)"
  },
  "sizes.layout.contentHeightWithAnnouncement": {
    "value": "calc(100vh - 174px)",
    "variable": "var(--sizes-layout-content-height-with-announcement)"
  },
  "sizes.layout.bottomNavHeight": {
    "value": "56px",
    "variable": "var(--sizes-layout-bottom-nav-height)"
  },
  "sizes.layout.earnClaimBannerHeight": {
    "value": "56px",
    "variable": "var(--sizes-layout-earn-claim-banner-height)"
  },
  "sizes.leverup.0": {
    "value": "0px",
    "variable": "var(--sizes-leverup-0)"
  },
  "sizes.leverup.1": {
    "value": "4px",
    "variable": "var(--sizes-leverup-1)"
  },
  "sizes.leverup.2": {
    "value": "8px",
    "variable": "var(--sizes-leverup-2)"
  },
  "sizes.leverup.3": {
    "value": "16px",
    "variable": "var(--sizes-leverup-3)"
  },
  "sizes.leverup.4": {
    "value": "32px",
    "variable": "var(--sizes-leverup-4)"
  },
  "sizes.leverup.5": {
    "value": "64px",
    "variable": "var(--sizes-leverup-5)"
  },
  "sizes.leverup.6": {
    "value": "128px",
    "variable": "var(--sizes-leverup-6)"
  },
  "sizes.leverup.7": {
    "value": "256px",
    "variable": "var(--sizes-leverup-7)"
  },
  "sizes.leverup.8": {
    "value": "512px",
    "variable": "var(--sizes-leverup-8)"
  },
  "sizes.leverup.3.5": {
    "value": "24px",
    "variable": "var(--sizes-leverup-3\\.5)"
  },
  "sizes.leverup.4.5": {
    "value": "40px",
    "variable": "var(--sizes-leverup-4\\.5)"
  },
  "sizes.2xs": {
    "value": "16rem",
    "variable": "var(--sizes-2xs)"
  },
  "sizes.xs": {
    "value": "20rem",
    "variable": "var(--sizes-xs)"
  },
  "sizes.sm": {
    "value": "24rem",
    "variable": "var(--sizes-sm)"
  },
  "sizes.md": {
    "value": "28rem",
    "variable": "var(--sizes-md)"
  },
  "sizes.lg": {
    "value": "32rem",
    "variable": "var(--sizes-lg)"
  },
  "sizes.xl": {
    "value": "36rem",
    "variable": "var(--sizes-xl)"
  },
  "sizes.2xl": {
    "value": "42rem",
    "variable": "var(--sizes-2xl)"
  },
  "sizes.3xl": {
    "value": "48rem",
    "variable": "var(--sizes-3xl)"
  },
  "sizes.4xl": {
    "value": "56rem",
    "variable": "var(--sizes-4xl)"
  },
  "sizes.5xl": {
    "value": "64rem",
    "variable": "var(--sizes-5xl)"
  },
  "sizes.6xl": {
    "value": "72rem",
    "variable": "var(--sizes-6xl)"
  },
  "sizes.7xl": {
    "value": "80rem",
    "variable": "var(--sizes-7xl)"
  },
  "sizes.8xl": {
    "value": "90rem",
    "variable": "var(--sizes-8xl)"
  },
  "sizes.tooltipDefaultWidth": {
    "value": "250px",
    "variable": "var(--sizes-tooltip-default-width)"
  },
  "sizes.buttonSizes.default": {
    "value": "56px",
    "variable": "var(--sizes-button-sizes-default)"
  },
  "sizes.full": {
    "value": "100%",
    "variable": "var(--sizes-full)"
  },
  "sizes.min": {
    "value": "min-content",
    "variable": "var(--sizes-min)"
  },
  "sizes.max": {
    "value": "max-content",
    "variable": "var(--sizes-max)"
  },
  "sizes.fit": {
    "value": "fit-content",
    "variable": "var(--sizes-fit)"
  },
  "sizes.breakpoint-sm": {
    "value": "640px",
    "variable": "var(--sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "768px",
    "variable": "var(--sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "1024px",
    "variable": "var(--sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "1280px",
    "variable": "var(--sizes-breakpoint-xl)"
  },
  "sizes.breakpoint-2xl": {
    "value": "1536px",
    "variable": "var(--sizes-breakpoint-2xl)"
  },
  "sizes.breakpoint-mobile": {
    "value": "375px",
    "variable": "var(--sizes-breakpoint-mobile)"
  },
  "sizes.breakpoint-tablet": {
    "value": "768px",
    "variable": "var(--sizes-breakpoint-tablet)"
  },
  "sizes.breakpoint-desktop": {
    "value": "992px",
    "variable": "var(--sizes-breakpoint-desktop)"
  },
  "sizes.breakpoint-desktopLg": {
    "value": "1440px",
    "variable": "var(--sizes-breakpoint-desktop-lg)"
  },
  "gradients.G.01": {
    "value": "linear-gradient(153.13deg, #373E44 0.01%, #191B1F 99.69%)",
    "variable": "var(--gradients--g-01)"
  },
  "gradients.G.leaderBoardGradient": {
    "value": "linear-gradient(180deg, #DCEFFF 3.07%, #D9D9D9 100%)",
    "variable": "var(--gradients--g-leader-board-gradient)"
  },
  "gradients.unCategorized.green": {
    "value": "linear-gradient(272deg, rgba(30, 168, 101, 0.20) 0%, #181818 100%), #151E21",
    "variable": "var(--gradients-un-categorized-green)"
  },
  "animations.backdrop-in": {
    "value": "fade-in 250ms var(--easings-emphasized-in)",
    "variable": "var(--animations-backdrop-in)"
  },
  "animations.backdrop-out": {
    "value": "fade-out 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-backdrop-out)"
  },
  "animations.dialog-in": {
    "value": "slide-in 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-dialog-in)"
  },
  "animations.dialog-out": {
    "value": "slide-out 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-dialog-out)"
  },
  "animations.drawer-in-left": {
    "value": "slide-in-left 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-drawer-in-left)"
  },
  "animations.drawer-out-left": {
    "value": "slide-out-left 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-drawer-out-left)"
  },
  "animations.drawer-in-right": {
    "value": "slide-in-right 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-drawer-in-right)"
  },
  "animations.drawer-out-right": {
    "value": "slide-out-right 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-drawer-out-right)"
  },
  "animations.skeleton-pulse": {
    "value": "skeleton-pulse 2s var(--easings-pulse) infinite",
    "variable": "var(--animations-skeleton-pulse)"
  },
  "animations.fade-in": {
    "value": "fade-in 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-fade-in)"
  },
  "animations.collapse-in": {
    "value": "collapse-in 250ms var(--easings-emphasized-in)",
    "variable": "var(--animations-collapse-in)"
  },
  "animations.collapse-out": {
    "value": "collapse-out 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-collapse-out)"
  },
  "animations.spin": {
    "value": "spin 1s linear infinite",
    "variable": "var(--animations-spin)"
  },
  "animations.drawer-in-bottom": {
    "value": "slide-in-bottom 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-drawer-in-bottom)"
  },
  "animations.drawer-out-bottom": {
    "value": "slide-out-bottom 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-drawer-out-bottom)"
  },
  "zIndex.hide": {
    "value": -1,
    "variable": "var(--z-index-hide)"
  },
  "zIndex.base": {
    "value": 0,
    "variable": "var(--z-index-base)"
  },
  "zIndex.docked": {
    "value": 10,
    "variable": "var(--z-index-docked)"
  },
  "zIndex.dropdown": {
    "value": 1000,
    "variable": "var(--z-index-dropdown)"
  },
  "zIndex.sticky": {
    "value": 1100,
    "variable": "var(--z-index-sticky)"
  },
  "zIndex.popover": {
    "value": 1110,
    "variable": "var(--z-index-popover)"
  },
  "zIndex.tooltip": {
    "value": 1120,
    "variable": "var(--z-index-tooltip)"
  },
  "zIndex.banner": {
    "value": 1200,
    "variable": "var(--z-index-banner)"
  },
  "zIndex.overlay": {
    "value": 1300,
    "variable": "var(--z-index-overlay)"
  },
  "zIndex.modal": {
    "value": 1400,
    "variable": "var(--z-index-modal)"
  },
  "zIndex.skipLink": {
    "value": 1600,
    "variable": "var(--z-index-skip-link)"
  },
  "zIndex.toast": {
    "value": 1700,
    "variable": "var(--z-index-toast)"
  },
  "breakpoints.sm": {
    "value": "640px",
    "variable": "var(--breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "768px",
    "variable": "var(--breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "1024px",
    "variable": "var(--breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "1280px",
    "variable": "var(--breakpoints-xl)"
  },
  "breakpoints.2xl": {
    "value": "1536px",
    "variable": "var(--breakpoints-2xl)"
  },
  "breakpoints.mobile": {
    "value": "375px",
    "variable": "var(--breakpoints-mobile)"
  },
  "breakpoints.tablet": {
    "value": "768px",
    "variable": "var(--breakpoints-tablet)"
  },
  "breakpoints.desktop": {
    "value": "992px",
    "variable": "var(--breakpoints-desktop)"
  },
  "breakpoints.desktopLg": {
    "value": "1440px",
    "variable": "var(--breakpoints-desktop-lg)"
  },
  "radii.l1": {
    "value": "var(--radii-xs)",
    "variable": "var(--radii-l1)"
  },
  "radii.l2": {
    "value": "var(--radii-sm)",
    "variable": "var(--radii-l2)"
  },
  "radii.l3": {
    "value": "var(--radii-md)",
    "variable": "var(--radii-l3)"
  },
  "colors.buttonPrimary.fg": {
    "value": "var(--colors-v2-text-on-accent)",
    "variable": "var(--colors-button-primary-fg)"
  },
  "colors.buttonPrimary.default": {
    "value": "var(--colors-primary-primary)",
    "variable": "var(--colors-button-primary-default)"
  },
  "colors.buttonPrimary.emphasized": {
    "value": "var(--colors-v2-long-strong)",
    "variable": "var(--colors-button-primary-emphasized)"
  },
  "colors.chainSwitch.fg": {
    "value": "var(--colors-grey-white-light-grey2)",
    "variable": "var(--colors-chain-switch-fg)"
  },
  "colors.chainSwitch.default": {
    "value": "var(--colors-black-lv3)",
    "variable": "var(--colors-chain-switch-default)"
  },
  "colors.chainSwitch.emphasized": {
    "value": "var(--colors-black-lv3)",
    "variable": "var(--colors-chain-switch-emphasized)"
  },
  "colors.tier.gold": {
    "value": "var(--colors-v2-vip-gold)",
    "variable": "var(--colors-tier-gold)"
  },
  "colors.tier.silver": {
    "value": "var(--colors-grey-white-light-grey4)",
    "variable": "var(--colors-tier-silver)"
  },
  "colors.tier.bronze": {
    "value": "#94604A",
    "variable": "var(--colors-tier-bronze)"
  },
  "colors.darkTheme.subtitle": {
    "value": "var(--colors-v2-text-muted)",
    "variable": "var(--colors-dark-theme-subtitle)"
  },
  "colors.campaignCard.fg": {
    "value": "#2C4255",
    "variable": "var(--colors-campaign-card-fg)"
  },
  "colors.blackPalette.bg": {
    "value": "var(--colors-black-full-black)",
    "variable": "var(--colors-black-palette-bg)"
  },
  "colors.blackPalette.fg": {
    "value": "var(--colors-grey-white-light-grey1)",
    "variable": "var(--colors-black-palette-fg)"
  },
  "colors.blackPalette.default": {
    "value": "var(--colors-black-full-black)",
    "variable": "var(--colors-black-palette-default)"
  },
  "colors.blackPalette.emphasized": {
    "value": "var(--colors-black-background)",
    "variable": "var(--colors-black-palette-emphasized)"
  },
  "colors.sliderLeverage.bg": {
    "value": "var(--colors-black-background)",
    "variable": "var(--colors-slider-leverage-bg)"
  },
  "colors.sliderLeverage.fg": {
    "value": "var(--colors-grey-white-light-grey4)",
    "variable": "var(--colors-slider-leverage-fg)"
  },
  "colors.sliderLeverage.default": {
    "value": "var(--colors-v2-bg-surface3)",
    "variable": "var(--colors-slider-leverage-default)"
  },
  "colors.sliderLeverage.emphasized": {
    "value": "var(--colors-grey-white-light-grey2)",
    "variable": "var(--colors-slider-leverage-emphasized)"
  },
  "colors.slider.bg": {
    "value": "var(--colors-black-background)",
    "variable": "var(--colors-slider-bg)"
  },
  "colors.slider.fg": {
    "value": "var(--colors-grey-white-light-grey4)",
    "variable": "var(--colors-slider-fg)"
  },
  "colors.slider.default": {
    "value": "var(--colors-v2-bg-surface3)",
    "variable": "var(--colors-slider-default)"
  },
  "colors.slider.emphasized": {
    "value": "var(--colors-grey-white-light-grey4)",
    "variable": "var(--colors-slider-emphasized)"
  },
  "colors.priceChart.default": {
    "value": "var(--colors-v2-bg-panel)",
    "variable": "var(--colors-price-chart-default)"
  },
  "colors.priceChart.bg": {
    "value": "var(--colors-v2-bg-panel)",
    "variable": "var(--colors-price-chart-bg)"
  },
  "colors.priceUp.emphasized": {
    "value": "var(--colors-price-price-up-emphasized)",
    "variable": "var(--colors-price-up-emphasized)"
  },
  "colors.priceUp.fg": {
    "value": "var(--colors-v2-text-on-accent)",
    "variable": "var(--colors-price-up-fg)"
  },
  "colors.priceUp.default": {
    "value": "var(--colors-price-price-up)",
    "variable": "var(--colors-price-up-default)"
  },
  "colors.priceDown.emphasized": {
    "value": "var(--colors-price-price-down-emphasized)",
    "variable": "var(--colors-price-down-emphasized)"
  },
  "colors.priceDown.fg": {
    "value": "white",
    "variable": "var(--colors-price-down-fg)"
  },
  "colors.priceDown.default": {
    "value": "var(--colors-price-price-down)",
    "variable": "var(--colors-price-down-default)"
  },
  "colors.buttonGrey.emphasized": {
    "value": "var(--colors-black-lv3)",
    "variable": "var(--colors-button-grey-emphasized)"
  },
  "colors.buttonGrey.fg": {
    "value": "var(--colors-grey-white-light-grey2)",
    "variable": "var(--colors-button-grey-fg)"
  },
  "colors.buttonGrey.default": {
    "value": "var(--colors-black-lv3)",
    "variable": "var(--colors-button-grey-default)"
  },
  "colors.campaign.brown": {
    "value": "#C56C0A",
    "variable": "var(--colors-campaign-brown)"
  },
  "colors.campaign.bg": {
    "value": "#62707C",
    "variable": "var(--colors-campaign-bg)"
  },
  "colors.campaign.descBg": {
    "value": "#515F6A",
    "variable": "var(--colors-campaign-desc-bg)"
  },
  "colors.campaign.descBorder": {
    "value": "#4B5661",
    "variable": "var(--colors-campaign-desc-border)"
  },
  "colors.campaign.titleGreyColor": {
    "value": "#848484",
    "variable": "var(--colors-campaign-title-grey-color)"
  },
  "colors.campaign.countDownBorderColor": {
    "value": "#383838",
    "variable": "var(--colors-campaign-count-down-border-color)"
  },
  "colors.campaign.countDownBgColor": {
    "value": "#22242A",
    "variable": "var(--colors-campaign-count-down-bg-color)"
  },
  "colors.campaign.countDownDescItemColor": {
    "value": "#FF8A00",
    "variable": "var(--colors-campaign-count-down-desc-item-color)"
  },
  "colors.campaign.countDownTextColor": {
    "value": "#8DD683",
    "variable": "var(--colors-campaign-count-down-text-color)"
  },
  "colors.campaign.switchThumb": {
    "value": "#30A6CB",
    "variable": "var(--colors-campaign-switch-thumb)"
  },
  "shadows.edge": {
    "value": "0 0 0 1px var(--colors-v2-border-default)",
    "variable": "var(--shadows-edge)"
  },
  "shadows.modal": {
    "value": "0 12px 32px rgba(0, 0, 0, 0.55)",
    "variable": "var(--shadows-modal)"
  },
  "shadows.sheet": {
    "value": "0 -8px 24px rgba(0, 0, 0, 0.45)",
    "variable": "var(--shadows-sheet)"
  },
  "shadows.glowLong": {
    "value": "0 0 0 1px var(--colors-v2-long-border), 0 0 16px rgba(199, 245, 13, 0.22)",
    "variable": "var(--shadows-glow-long)"
  },
  "shadows.glowShort": {
    "value": "0 0 0 1px var(--colors-v2-short-border), 0 0 16px rgba(250, 80, 0, 0.22)",
    "variable": "var(--shadows-glow-short)"
  },
  "shadows.floatingLv1": {
    "value": "none",
    "variable": "var(--shadows-floating-lv1)"
  },
  "shadows.floatingLv2": {
    "value": "none",
    "variable": "var(--shadows-floating-lv2)"
  },
  "shadows.floatingLv3": {
    "value": "0 0 0 1px var(--colors-v2-border-default)",
    "variable": "var(--shadows-floating-lv3)"
  },
  "shadows.floatingLv4": {
    "value": "0 0 0 1px var(--colors-v2-border-default)",
    "variable": "var(--shadows-floating-lv4)"
  },
  "shadows.pressingBackground": {
    "value": "none",
    "variable": "var(--shadows-pressing-background)"
  },
  "shadows.pressingLv1": {
    "value": "none",
    "variable": "var(--shadows-pressing-lv1)"
  },
  "shadows.pressingLv2": {
    "value": "none",
    "variable": "var(--shadows-pressing-lv2)"
  },
  "shadows.pressingLv3": {
    "value": "none",
    "variable": "var(--shadows-pressing-lv3)"
  },
  "shadows.softCard1": {
    "value": "none",
    "variable": "var(--shadows-soft-card1)"
  },
  "shadows.softCard2": {
    "value": "none",
    "variable": "var(--shadows-soft-card2)"
  },
  "shadows.floatingCard1": {
    "value": "none",
    "variable": "var(--shadows-floating-card1)"
  },
  "shadows.floatingCard2": {
    "value": "none",
    "variable": "var(--shadows-floating-card2)"
  },
  "shadows.textGlow1": {
    "value": "none",
    "variable": "var(--shadows-text-glow1)"
  },
  "spacing.-1": {
    "value": "calc(var(--spacing-1) * -1)",
    "variable": "var(--spacing-1)"
  },
  "spacing.-2": {
    "value": "calc(var(--spacing-2) * -1)",
    "variable": "var(--spacing-2)"
  },
  "spacing.-3": {
    "value": "calc(var(--spacing-3) * -1)",
    "variable": "var(--spacing-3)"
  },
  "spacing.-4": {
    "value": "calc(var(--spacing-4) * -1)",
    "variable": "var(--spacing-4)"
  },
  "spacing.-5": {
    "value": "calc(var(--spacing-5) * -1)",
    "variable": "var(--spacing-5)"
  },
  "spacing.-6": {
    "value": "calc(var(--spacing-6) * -1)",
    "variable": "var(--spacing-6)"
  },
  "spacing.-7": {
    "value": "calc(var(--spacing-7) * -1)",
    "variable": "var(--spacing-7)"
  },
  "spacing.-8": {
    "value": "calc(var(--spacing-8) * -1)",
    "variable": "var(--spacing-8)"
  },
  "spacing.-9": {
    "value": "calc(var(--spacing-9) * -1)",
    "variable": "var(--spacing-9)"
  },
  "spacing.-10": {
    "value": "calc(var(--spacing-10) * -1)",
    "variable": "var(--spacing-10)"
  },
  "spacing.-11": {
    "value": "calc(var(--spacing-11) * -1)",
    "variable": "var(--spacing-11)"
  },
  "spacing.-12": {
    "value": "calc(var(--spacing-12) * -1)",
    "variable": "var(--spacing-12)"
  },
  "spacing.-14": {
    "value": "calc(var(--spacing-14) * -1)",
    "variable": "var(--spacing-14)"
  },
  "spacing.-16": {
    "value": "calc(var(--spacing-16) * -1)",
    "variable": "var(--spacing-16)"
  },
  "spacing.-20": {
    "value": "calc(var(--spacing-20) * -1)",
    "variable": "var(--spacing-20)"
  },
  "spacing.-24": {
    "value": "calc(var(--spacing-24) * -1)",
    "variable": "var(--spacing-24)"
  },
  "spacing.-28": {
    "value": "calc(var(--spacing-28) * -1)",
    "variable": "var(--spacing-28)"
  },
  "spacing.-32": {
    "value": "calc(var(--spacing-32) * -1)",
    "variable": "var(--spacing-32)"
  },
  "spacing.-36": {
    "value": "calc(var(--spacing-36) * -1)",
    "variable": "var(--spacing-36)"
  },
  "spacing.-40": {
    "value": "calc(var(--spacing-40) * -1)",
    "variable": "var(--spacing-40)"
  },
  "spacing.-44": {
    "value": "calc(var(--spacing-44) * -1)",
    "variable": "var(--spacing-44)"
  },
  "spacing.-48": {
    "value": "calc(var(--spacing-48) * -1)",
    "variable": "var(--spacing-48)"
  },
  "spacing.-52": {
    "value": "calc(var(--spacing-52) * -1)",
    "variable": "var(--spacing-52)"
  },
  "spacing.-56": {
    "value": "calc(var(--spacing-56) * -1)",
    "variable": "var(--spacing-56)"
  },
  "spacing.-60": {
    "value": "calc(var(--spacing-60) * -1)",
    "variable": "var(--spacing-60)"
  },
  "spacing.-64": {
    "value": "calc(var(--spacing-64) * -1)",
    "variable": "var(--spacing-64)"
  },
  "spacing.-72": {
    "value": "calc(var(--spacing-72) * -1)",
    "variable": "var(--spacing-72)"
  },
  "spacing.-80": {
    "value": "calc(var(--spacing-80) * -1)",
    "variable": "var(--spacing-80)"
  },
  "spacing.-96": {
    "value": "calc(var(--spacing-96) * -1)",
    "variable": "var(--spacing-96)"
  },
  "spacing.-0.5": {
    "value": "calc(var(--spacing-0\\.5) * -1)",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.-1.5": {
    "value": "calc(var(--spacing-1\\.5) * -1)",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.-2.5": {
    "value": "calc(var(--spacing-2\\.5) * -1)",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.-3.5": {
    "value": "calc(var(--spacing-3\\.5) * -1)",
    "variable": "var(--spacing-3\\.5)"
  },
  "spacing.-4.5": {
    "value": "calc(var(--spacing-4\\.5) * -1)",
    "variable": "var(--spacing-4\\.5)"
  },
  "spacing.layout.-topNavBarHeight": {
    "value": "calc(var(--spacing-layout-top-nav-bar-height) * -1)",
    "variable": "var(--spacing-layout-top-nav-bar-height)"
  },
  "spacing.layout.-announcementHeight": {
    "value": "calc(var(--spacing-layout-announcement-height) * -1)",
    "variable": "var(--spacing-layout-announcement-height)"
  },
  "spacing.layout.-pairInfoBarHeight": {
    "value": "calc(var(--spacing-layout-pair-info-bar-height) * -1)",
    "variable": "var(--spacing-layout-pair-info-bar-height)"
  },
  "spacing.layout.-topNavBarWithAnnouncementHeight": {
    "value": "calc(var(--spacing-layout-top-nav-bar-with-announcement-height) * -1)",
    "variable": "var(--spacing-layout-top-nav-bar-with-announcement-height)"
  },
  "spacing.layout.-contentHeight": {
    "value": "calc(var(--spacing-layout-content-height) * -1)",
    "variable": "var(--spacing-layout-content-height)"
  },
  "spacing.layout.-contentHeightWithAnnouncement": {
    "value": "calc(var(--spacing-layout-content-height-with-announcement) * -1)",
    "variable": "var(--spacing-layout-content-height-with-announcement)"
  },
  "spacing.layout.-bottomNavHeight": {
    "value": "calc(var(--spacing-layout-bottom-nav-height) * -1)",
    "variable": "var(--spacing-layout-bottom-nav-height)"
  },
  "spacing.layout.-earnClaimBannerHeight": {
    "value": "calc(var(--spacing-layout-earn-claim-banner-height) * -1)",
    "variable": "var(--spacing-layout-earn-claim-banner-height)"
  },
  "spacing.leverup.-0": {
    "value": "calc(var(--spacing-leverup-0) * -1)",
    "variable": "var(--spacing-leverup-0)"
  },
  "spacing.leverup.-1": {
    "value": "calc(var(--spacing-leverup-1) * -1)",
    "variable": "var(--spacing-leverup-1)"
  },
  "spacing.leverup.-2": {
    "value": "calc(var(--spacing-leverup-2) * -1)",
    "variable": "var(--spacing-leverup-2)"
  },
  "spacing.leverup.-3": {
    "value": "calc(var(--spacing-leverup-3) * -1)",
    "variable": "var(--spacing-leverup-3)"
  },
  "spacing.leverup.-4": {
    "value": "calc(var(--spacing-leverup-4) * -1)",
    "variable": "var(--spacing-leverup-4)"
  },
  "spacing.leverup.-5": {
    "value": "calc(var(--spacing-leverup-5) * -1)",
    "variable": "var(--spacing-leverup-5)"
  },
  "spacing.leverup.-6": {
    "value": "calc(var(--spacing-leverup-6) * -1)",
    "variable": "var(--spacing-leverup-6)"
  },
  "spacing.leverup.-7": {
    "value": "calc(var(--spacing-leverup-7) * -1)",
    "variable": "var(--spacing-leverup-7)"
  },
  "spacing.leverup.-8": {
    "value": "calc(var(--spacing-leverup-8) * -1)",
    "variable": "var(--spacing-leverup-8)"
  },
  "spacing.leverup.-3.5": {
    "value": "calc(var(--spacing-leverup-3\\.5) * -1)",
    "variable": "var(--spacing-leverup-3\\.5)"
  },
  "spacing.leverup.-4.5": {
    "value": "calc(var(--spacing-leverup-4\\.5) * -1)",
    "variable": "var(--spacing-leverup-4\\.5)"
  },
  "colors.neutral.1": {
    "value": "var(--colors-neutral-1)",
    "variable": "var(--colors-neutral-1)"
  },
  "colors.neutral.2": {
    "value": "var(--colors-neutral-2)",
    "variable": "var(--colors-neutral-2)"
  },
  "colors.neutral.3": {
    "value": "var(--colors-neutral-3)",
    "variable": "var(--colors-neutral-3)"
  },
  "colors.neutral.4": {
    "value": "var(--colors-neutral-4)",
    "variable": "var(--colors-neutral-4)"
  },
  "colors.neutral.5": {
    "value": "var(--colors-neutral-5)",
    "variable": "var(--colors-neutral-5)"
  },
  "colors.neutral.6": {
    "value": "var(--colors-neutral-6)",
    "variable": "var(--colors-neutral-6)"
  },
  "colors.neutral.7": {
    "value": "var(--colors-neutral-7)",
    "variable": "var(--colors-neutral-7)"
  },
  "colors.neutral.8": {
    "value": "var(--colors-neutral-8)",
    "variable": "var(--colors-neutral-8)"
  },
  "colors.neutral.9": {
    "value": "var(--colors-neutral-9)",
    "variable": "var(--colors-neutral-9)"
  },
  "colors.neutral.10": {
    "value": "var(--colors-neutral-10)",
    "variable": "var(--colors-neutral-10)"
  },
  "colors.neutral.11": {
    "value": "var(--colors-neutral-11)",
    "variable": "var(--colors-neutral-11)"
  },
  "colors.neutral.12": {
    "value": "var(--colors-neutral-12)",
    "variable": "var(--colors-neutral-12)"
  },
  "colors.neutral.a1": {
    "value": "var(--colors-neutral-a1)",
    "variable": "var(--colors-neutral-a1)"
  },
  "colors.neutral.a2": {
    "value": "var(--colors-neutral-a2)",
    "variable": "var(--colors-neutral-a2)"
  },
  "colors.neutral.a3": {
    "value": "var(--colors-neutral-a3)",
    "variable": "var(--colors-neutral-a3)"
  },
  "colors.neutral.a4": {
    "value": "var(--colors-neutral-a4)",
    "variable": "var(--colors-neutral-a4)"
  },
  "colors.neutral.a5": {
    "value": "var(--colors-neutral-a5)",
    "variable": "var(--colors-neutral-a5)"
  },
  "colors.neutral.a6": {
    "value": "var(--colors-neutral-a6)",
    "variable": "var(--colors-neutral-a6)"
  },
  "colors.neutral.a7": {
    "value": "var(--colors-neutral-a7)",
    "variable": "var(--colors-neutral-a7)"
  },
  "colors.neutral.a8": {
    "value": "var(--colors-neutral-a8)",
    "variable": "var(--colors-neutral-a8)"
  },
  "colors.neutral.a9": {
    "value": "var(--colors-neutral-a9)",
    "variable": "var(--colors-neutral-a9)"
  },
  "colors.neutral.a10": {
    "value": "var(--colors-neutral-a10)",
    "variable": "var(--colors-neutral-a10)"
  },
  "colors.neutral.a11": {
    "value": "var(--colors-neutral-a11)",
    "variable": "var(--colors-neutral-a11)"
  },
  "colors.neutral.a12": {
    "value": "var(--colors-neutral-a12)",
    "variable": "var(--colors-neutral-a12)"
  },
  "colors.neutral.default": {
    "value": "var(--colors-neutral-default)",
    "variable": "var(--colors-neutral-default)"
  },
  "colors.neutral.emphasized": {
    "value": "var(--colors-neutral-emphasized)",
    "variable": "var(--colors-neutral-emphasized)"
  },
  "colors.neutral.fg": {
    "value": "var(--colors-neutral-fg)",
    "variable": "var(--colors-neutral-fg)"
  },
  "colors.neutral.text": {
    "value": "var(--colors-neutral-text)",
    "variable": "var(--colors-neutral-text)"
  },
  "colors.red.1": {
    "value": "var(--colors-red-1)",
    "variable": "var(--colors-red-1)"
  },
  "colors.red.2": {
    "value": "var(--colors-red-2)",
    "variable": "var(--colors-red-2)"
  },
  "colors.red.3": {
    "value": "var(--colors-red-3)",
    "variable": "var(--colors-red-3)"
  },
  "colors.red.4": {
    "value": "var(--colors-red-4)",
    "variable": "var(--colors-red-4)"
  },
  "colors.red.5": {
    "value": "var(--colors-red-5)",
    "variable": "var(--colors-red-5)"
  },
  "colors.red.6": {
    "value": "var(--colors-red-6)",
    "variable": "var(--colors-red-6)"
  },
  "colors.red.7": {
    "value": "var(--colors-red-7)",
    "variable": "var(--colors-red-7)"
  },
  "colors.red.8": {
    "value": "var(--colors-red-8)",
    "variable": "var(--colors-red-8)"
  },
  "colors.red.9": {
    "value": "var(--colors-red-9)",
    "variable": "var(--colors-red-9)"
  },
  "colors.red.10": {
    "value": "var(--colors-red-10)",
    "variable": "var(--colors-red-10)"
  },
  "colors.red.11": {
    "value": "var(--colors-red-11)",
    "variable": "var(--colors-red-11)"
  },
  "colors.red.12": {
    "value": "var(--colors-red-12)",
    "variable": "var(--colors-red-12)"
  },
  "colors.red.a1": {
    "value": "var(--colors-red-a1)",
    "variable": "var(--colors-red-a1)"
  },
  "colors.red.a2": {
    "value": "var(--colors-red-a2)",
    "variable": "var(--colors-red-a2)"
  },
  "colors.red.a3": {
    "value": "var(--colors-red-a3)",
    "variable": "var(--colors-red-a3)"
  },
  "colors.red.a4": {
    "value": "var(--colors-red-a4)",
    "variable": "var(--colors-red-a4)"
  },
  "colors.red.a5": {
    "value": "var(--colors-red-a5)",
    "variable": "var(--colors-red-a5)"
  },
  "colors.red.a6": {
    "value": "var(--colors-red-a6)",
    "variable": "var(--colors-red-a6)"
  },
  "colors.red.a7": {
    "value": "var(--colors-red-a7)",
    "variable": "var(--colors-red-a7)"
  },
  "colors.red.a8": {
    "value": "var(--colors-red-a8)",
    "variable": "var(--colors-red-a8)"
  },
  "colors.red.a9": {
    "value": "var(--colors-red-a9)",
    "variable": "var(--colors-red-a9)"
  },
  "colors.red.a10": {
    "value": "var(--colors-red-a10)",
    "variable": "var(--colors-red-a10)"
  },
  "colors.red.a11": {
    "value": "var(--colors-red-a11)",
    "variable": "var(--colors-red-a11)"
  },
  "colors.red.a12": {
    "value": "var(--colors-red-a12)",
    "variable": "var(--colors-red-a12)"
  },
  "colors.red.default": {
    "value": "var(--colors-red-default)",
    "variable": "var(--colors-red-default)"
  },
  "colors.red.emphasized": {
    "value": "var(--colors-red-emphasized)",
    "variable": "var(--colors-red-emphasized)"
  },
  "colors.red.fg": {
    "value": "var(--colors-red-fg)",
    "variable": "var(--colors-red-fg)"
  },
  "colors.red.text": {
    "value": "var(--colors-red-text)",
    "variable": "var(--colors-red-text)"
  },
  "colors.gray.1": {
    "value": "var(--colors-gray-1)",
    "variable": "var(--colors-gray-1)"
  },
  "colors.gray.2": {
    "value": "var(--colors-gray-2)",
    "variable": "var(--colors-gray-2)"
  },
  "colors.gray.3": {
    "value": "var(--colors-gray-3)",
    "variable": "var(--colors-gray-3)"
  },
  "colors.gray.4": {
    "value": "var(--colors-gray-4)",
    "variable": "var(--colors-gray-4)"
  },
  "colors.gray.5": {
    "value": "var(--colors-gray-5)",
    "variable": "var(--colors-gray-5)"
  },
  "colors.gray.6": {
    "value": "var(--colors-gray-6)",
    "variable": "var(--colors-gray-6)"
  },
  "colors.gray.7": {
    "value": "var(--colors-gray-7)",
    "variable": "var(--colors-gray-7)"
  },
  "colors.gray.8": {
    "value": "var(--colors-gray-8)",
    "variable": "var(--colors-gray-8)"
  },
  "colors.gray.9": {
    "value": "var(--colors-gray-9)",
    "variable": "var(--colors-gray-9)"
  },
  "colors.gray.10": {
    "value": "var(--colors-gray-10)",
    "variable": "var(--colors-gray-10)"
  },
  "colors.gray.11": {
    "value": "var(--colors-gray-11)",
    "variable": "var(--colors-gray-11)"
  },
  "colors.gray.12": {
    "value": "var(--colors-gray-12)",
    "variable": "var(--colors-gray-12)"
  },
  "colors.gray.a1": {
    "value": "var(--colors-gray-a1)",
    "variable": "var(--colors-gray-a1)"
  },
  "colors.gray.a2": {
    "value": "var(--colors-gray-a2)",
    "variable": "var(--colors-gray-a2)"
  },
  "colors.gray.a3": {
    "value": "var(--colors-gray-a3)",
    "variable": "var(--colors-gray-a3)"
  },
  "colors.gray.a4": {
    "value": "var(--colors-gray-a4)",
    "variable": "var(--colors-gray-a4)"
  },
  "colors.gray.a5": {
    "value": "var(--colors-gray-a5)",
    "variable": "var(--colors-gray-a5)"
  },
  "colors.gray.a6": {
    "value": "var(--colors-gray-a6)",
    "variable": "var(--colors-gray-a6)"
  },
  "colors.gray.a7": {
    "value": "var(--colors-gray-a7)",
    "variable": "var(--colors-gray-a7)"
  },
  "colors.gray.a8": {
    "value": "var(--colors-gray-a8)",
    "variable": "var(--colors-gray-a8)"
  },
  "colors.gray.a9": {
    "value": "var(--colors-gray-a9)",
    "variable": "var(--colors-gray-a9)"
  },
  "colors.gray.a10": {
    "value": "var(--colors-gray-a10)",
    "variable": "var(--colors-gray-a10)"
  },
  "colors.gray.a11": {
    "value": "var(--colors-gray-a11)",
    "variable": "var(--colors-gray-a11)"
  },
  "colors.gray.a12": {
    "value": "var(--colors-gray-a12)",
    "variable": "var(--colors-gray-a12)"
  },
  "colors.gray.default": {
    "value": "var(--colors-gray-default)",
    "variable": "var(--colors-gray-default)"
  },
  "colors.gray.emphasized": {
    "value": "var(--colors-gray-emphasized)",
    "variable": "var(--colors-gray-emphasized)"
  },
  "colors.gray.fg": {
    "value": "var(--colors-gray-fg)",
    "variable": "var(--colors-gray-fg)"
  },
  "colors.gray.text": {
    "value": "var(--colors-gray-text)",
    "variable": "var(--colors-gray-text)"
  },
  "colors.accent.1": {
    "value": "var(--colors-accent-1)",
    "variable": "var(--colors-accent-1)"
  },
  "colors.accent.2": {
    "value": "var(--colors-accent-2)",
    "variable": "var(--colors-accent-2)"
  },
  "colors.accent.3": {
    "value": "var(--colors-accent-3)",
    "variable": "var(--colors-accent-3)"
  },
  "colors.accent.4": {
    "value": "var(--colors-accent-4)",
    "variable": "var(--colors-accent-4)"
  },
  "colors.accent.5": {
    "value": "var(--colors-accent-5)",
    "variable": "var(--colors-accent-5)"
  },
  "colors.accent.6": {
    "value": "var(--colors-accent-6)",
    "variable": "var(--colors-accent-6)"
  },
  "colors.accent.7": {
    "value": "var(--colors-accent-7)",
    "variable": "var(--colors-accent-7)"
  },
  "colors.accent.8": {
    "value": "var(--colors-accent-8)",
    "variable": "var(--colors-accent-8)"
  },
  "colors.accent.9": {
    "value": "var(--colors-accent-9)",
    "variable": "var(--colors-accent-9)"
  },
  "colors.accent.10": {
    "value": "var(--colors-accent-10)",
    "variable": "var(--colors-accent-10)"
  },
  "colors.accent.11": {
    "value": "var(--colors-accent-11)",
    "variable": "var(--colors-accent-11)"
  },
  "colors.accent.12": {
    "value": "var(--colors-accent-12)",
    "variable": "var(--colors-accent-12)"
  },
  "colors.accent.a1": {
    "value": "var(--colors-accent-a1)",
    "variable": "var(--colors-accent-a1)"
  },
  "colors.accent.a2": {
    "value": "var(--colors-accent-a2)",
    "variable": "var(--colors-accent-a2)"
  },
  "colors.accent.a3": {
    "value": "var(--colors-accent-a3)",
    "variable": "var(--colors-accent-a3)"
  },
  "colors.accent.a4": {
    "value": "var(--colors-accent-a4)",
    "variable": "var(--colors-accent-a4)"
  },
  "colors.accent.a5": {
    "value": "var(--colors-accent-a5)",
    "variable": "var(--colors-accent-a5)"
  },
  "colors.accent.a6": {
    "value": "var(--colors-accent-a6)",
    "variable": "var(--colors-accent-a6)"
  },
  "colors.accent.a7": {
    "value": "var(--colors-accent-a7)",
    "variable": "var(--colors-accent-a7)"
  },
  "colors.accent.a8": {
    "value": "var(--colors-accent-a8)",
    "variable": "var(--colors-accent-a8)"
  },
  "colors.accent.a9": {
    "value": "var(--colors-accent-a9)",
    "variable": "var(--colors-accent-a9)"
  },
  "colors.accent.a10": {
    "value": "var(--colors-accent-a10)",
    "variable": "var(--colors-accent-a10)"
  },
  "colors.accent.a11": {
    "value": "var(--colors-accent-a11)",
    "variable": "var(--colors-accent-a11)"
  },
  "colors.accent.a12": {
    "value": "var(--colors-accent-a12)",
    "variable": "var(--colors-accent-a12)"
  },
  "colors.accent.default": {
    "value": "var(--colors-accent-default)",
    "variable": "var(--colors-accent-default)"
  },
  "colors.accent.emphasized": {
    "value": "var(--colors-accent-emphasized)",
    "variable": "var(--colors-accent-emphasized)"
  },
  "colors.accent.fg": {
    "value": "var(--colors-accent-fg)",
    "variable": "var(--colors-accent-fg)"
  },
  "colors.accent.text": {
    "value": "var(--colors-accent-text)",
    "variable": "var(--colors-accent-text)"
  },
  "colors.bg.canvas": {
    "value": "var(--colors-bg-canvas)",
    "variable": "var(--colors-bg-canvas)"
  },
  "colors.bg.default": {
    "value": "var(--colors-bg-default)",
    "variable": "var(--colors-bg-default)"
  },
  "colors.bg.subtle": {
    "value": "var(--colors-bg-subtle)",
    "variable": "var(--colors-bg-subtle)"
  },
  "colors.bg.muted": {
    "value": "var(--colors-bg-muted)",
    "variable": "var(--colors-bg-muted)"
  },
  "colors.bg.emphasized": {
    "value": "var(--colors-bg-emphasized)",
    "variable": "var(--colors-bg-emphasized)"
  },
  "colors.bg.disabled": {
    "value": "var(--colors-bg-disabled)",
    "variable": "var(--colors-bg-disabled)"
  },
  "colors.fg.default": {
    "value": "var(--colors-fg-default)",
    "variable": "var(--colors-fg-default)"
  },
  "colors.fg.muted": {
    "value": "var(--colors-fg-muted)",
    "variable": "var(--colors-fg-muted)"
  },
  "colors.fg.subtle": {
    "value": "var(--colors-fg-subtle)",
    "variable": "var(--colors-fg-subtle)"
  },
  "colors.fg.disabled": {
    "value": "var(--colors-fg-disabled)",
    "variable": "var(--colors-fg-disabled)"
  },
  "colors.fg.error": {
    "value": "var(--colors-fg-error)",
    "variable": "var(--colors-fg-error)"
  },
  "colors.border.default": {
    "value": "var(--colors-border-default)",
    "variable": "var(--colors-border-default)"
  },
  "colors.border.muted": {
    "value": "var(--colors-border-muted)",
    "variable": "var(--colors-border-muted)"
  },
  "colors.border.subtle": {
    "value": "var(--colors-border-subtle)",
    "variable": "var(--colors-border-subtle)"
  },
  "colors.border.disabled": {
    "value": "var(--colors-border-disabled)",
    "variable": "var(--colors-border-disabled)"
  },
  "colors.border.outline": {
    "value": "var(--colors-border-outline)",
    "variable": "var(--colors-border-outline)"
  },
  "colors.border.error": {
    "value": "var(--colors-border-error)",
    "variable": "var(--colors-border-error)"
  },
  "shadows.xs": {
    "value": "var(--shadows-xs)",
    "variable": "var(--shadows-xs)"
  },
  "shadows.sm": {
    "value": "var(--shadows-sm)",
    "variable": "var(--shadows-sm)"
  },
  "shadows.md": {
    "value": "var(--shadows-md)",
    "variable": "var(--shadows-md)"
  },
  "shadows.lg": {
    "value": "var(--shadows-lg)",
    "variable": "var(--shadows-lg)"
  },
  "shadows.xl": {
    "value": "var(--shadows-xl)",
    "variable": "var(--shadows-xl)"
  },
  "shadows.2xl": {
    "value": "var(--shadows-2xl)",
    "variable": "var(--shadows-2xl)"
  },
  "colors.colorPalette": {
    "value": "var(--colors-color-palette)",
    "variable": "var(--colors-color-palette)"
  },
  "colors.colorPalette.a1": {
    "value": "var(--colors-color-palette-a1)",
    "variable": "var(--colors-color-palette-a1)"
  },
  "colors.colorPalette.a2": {
    "value": "var(--colors-color-palette-a2)",
    "variable": "var(--colors-color-palette-a2)"
  },
  "colors.colorPalette.a3": {
    "value": "var(--colors-color-palette-a3)",
    "variable": "var(--colors-color-palette-a3)"
  },
  "colors.colorPalette.a4": {
    "value": "var(--colors-color-palette-a4)",
    "variable": "var(--colors-color-palette-a4)"
  },
  "colors.colorPalette.a5": {
    "value": "var(--colors-color-palette-a5)",
    "variable": "var(--colors-color-palette-a5)"
  },
  "colors.colorPalette.a6": {
    "value": "var(--colors-color-palette-a6)",
    "variable": "var(--colors-color-palette-a6)"
  },
  "colors.colorPalette.a7": {
    "value": "var(--colors-color-palette-a7)",
    "variable": "var(--colors-color-palette-a7)"
  },
  "colors.colorPalette.a8": {
    "value": "var(--colors-color-palette-a8)",
    "variable": "var(--colors-color-palette-a8)"
  },
  "colors.colorPalette.a9": {
    "value": "var(--colors-color-palette-a9)",
    "variable": "var(--colors-color-palette-a9)"
  },
  "colors.colorPalette.a10": {
    "value": "var(--colors-color-palette-a10)",
    "variable": "var(--colors-color-palette-a10)"
  },
  "colors.colorPalette.a11": {
    "value": "var(--colors-color-palette-a11)",
    "variable": "var(--colors-color-palette-a11)"
  },
  "colors.colorPalette.a12": {
    "value": "var(--colors-color-palette-a12)",
    "variable": "var(--colors-color-palette-a12)"
  },
  "colors.colorPalette.light.1": {
    "value": "var(--colors-color-palette-light-1)",
    "variable": "var(--colors-color-palette-light-1)"
  },
  "colors.colorPalette.1": {
    "value": "var(--colors-color-palette-1)",
    "variable": "var(--colors-color-palette-1)"
  },
  "colors.colorPalette.light.2": {
    "value": "var(--colors-color-palette-light-2)",
    "variable": "var(--colors-color-palette-light-2)"
  },
  "colors.colorPalette.2": {
    "value": "var(--colors-color-palette-2)",
    "variable": "var(--colors-color-palette-2)"
  },
  "colors.colorPalette.light.3": {
    "value": "var(--colors-color-palette-light-3)",
    "variable": "var(--colors-color-palette-light-3)"
  },
  "colors.colorPalette.3": {
    "value": "var(--colors-color-palette-3)",
    "variable": "var(--colors-color-palette-3)"
  },
  "colors.colorPalette.light.4": {
    "value": "var(--colors-color-palette-light-4)",
    "variable": "var(--colors-color-palette-light-4)"
  },
  "colors.colorPalette.4": {
    "value": "var(--colors-color-palette-4)",
    "variable": "var(--colors-color-palette-4)"
  },
  "colors.colorPalette.light.5": {
    "value": "var(--colors-color-palette-light-5)",
    "variable": "var(--colors-color-palette-light-5)"
  },
  "colors.colorPalette.5": {
    "value": "var(--colors-color-palette-5)",
    "variable": "var(--colors-color-palette-5)"
  },
  "colors.colorPalette.light.6": {
    "value": "var(--colors-color-palette-light-6)",
    "variable": "var(--colors-color-palette-light-6)"
  },
  "colors.colorPalette.6": {
    "value": "var(--colors-color-palette-6)",
    "variable": "var(--colors-color-palette-6)"
  },
  "colors.colorPalette.light.7": {
    "value": "var(--colors-color-palette-light-7)",
    "variable": "var(--colors-color-palette-light-7)"
  },
  "colors.colorPalette.7": {
    "value": "var(--colors-color-palette-7)",
    "variable": "var(--colors-color-palette-7)"
  },
  "colors.colorPalette.light.8": {
    "value": "var(--colors-color-palette-light-8)",
    "variable": "var(--colors-color-palette-light-8)"
  },
  "colors.colorPalette.8": {
    "value": "var(--colors-color-palette-8)",
    "variable": "var(--colors-color-palette-8)"
  },
  "colors.colorPalette.light.9": {
    "value": "var(--colors-color-palette-light-9)",
    "variable": "var(--colors-color-palette-light-9)"
  },
  "colors.colorPalette.9": {
    "value": "var(--colors-color-palette-9)",
    "variable": "var(--colors-color-palette-9)"
  },
  "colors.colorPalette.light.10": {
    "value": "var(--colors-color-palette-light-10)",
    "variable": "var(--colors-color-palette-light-10)"
  },
  "colors.colorPalette.10": {
    "value": "var(--colors-color-palette-10)",
    "variable": "var(--colors-color-palette-10)"
  },
  "colors.colorPalette.light.11": {
    "value": "var(--colors-color-palette-light-11)",
    "variable": "var(--colors-color-palette-light-11)"
  },
  "colors.colorPalette.11": {
    "value": "var(--colors-color-palette-11)",
    "variable": "var(--colors-color-palette-11)"
  },
  "colors.colorPalette.light.12": {
    "value": "var(--colors-color-palette-light-12)",
    "variable": "var(--colors-color-palette-light-12)"
  },
  "colors.colorPalette.12": {
    "value": "var(--colors-color-palette-12)",
    "variable": "var(--colors-color-palette-12)"
  },
  "colors.colorPalette.light.a1": {
    "value": "var(--colors-color-palette-light-a1)",
    "variable": "var(--colors-color-palette-light-a1)"
  },
  "colors.colorPalette.light.a2": {
    "value": "var(--colors-color-palette-light-a2)",
    "variable": "var(--colors-color-palette-light-a2)"
  },
  "colors.colorPalette.light.a3": {
    "value": "var(--colors-color-palette-light-a3)",
    "variable": "var(--colors-color-palette-light-a3)"
  },
  "colors.colorPalette.light.a4": {
    "value": "var(--colors-color-palette-light-a4)",
    "variable": "var(--colors-color-palette-light-a4)"
  },
  "colors.colorPalette.light.a5": {
    "value": "var(--colors-color-palette-light-a5)",
    "variable": "var(--colors-color-palette-light-a5)"
  },
  "colors.colorPalette.light.a6": {
    "value": "var(--colors-color-palette-light-a6)",
    "variable": "var(--colors-color-palette-light-a6)"
  },
  "colors.colorPalette.light.a7": {
    "value": "var(--colors-color-palette-light-a7)",
    "variable": "var(--colors-color-palette-light-a7)"
  },
  "colors.colorPalette.light.a8": {
    "value": "var(--colors-color-palette-light-a8)",
    "variable": "var(--colors-color-palette-light-a8)"
  },
  "colors.colorPalette.light.a9": {
    "value": "var(--colors-color-palette-light-a9)",
    "variable": "var(--colors-color-palette-light-a9)"
  },
  "colors.colorPalette.light.a10": {
    "value": "var(--colors-color-palette-light-a10)",
    "variable": "var(--colors-color-palette-light-a10)"
  },
  "colors.colorPalette.light.a11": {
    "value": "var(--colors-color-palette-light-a11)",
    "variable": "var(--colors-color-palette-light-a11)"
  },
  "colors.colorPalette.light.a12": {
    "value": "var(--colors-color-palette-light-a12)",
    "variable": "var(--colors-color-palette-light-a12)"
  },
  "colors.colorPalette.dark.1": {
    "value": "var(--colors-color-palette-dark-1)",
    "variable": "var(--colors-color-palette-dark-1)"
  },
  "colors.colorPalette.dark.2": {
    "value": "var(--colors-color-palette-dark-2)",
    "variable": "var(--colors-color-palette-dark-2)"
  },
  "colors.colorPalette.dark.3": {
    "value": "var(--colors-color-palette-dark-3)",
    "variable": "var(--colors-color-palette-dark-3)"
  },
  "colors.colorPalette.dark.4": {
    "value": "var(--colors-color-palette-dark-4)",
    "variable": "var(--colors-color-palette-dark-4)"
  },
  "colors.colorPalette.dark.5": {
    "value": "var(--colors-color-palette-dark-5)",
    "variable": "var(--colors-color-palette-dark-5)"
  },
  "colors.colorPalette.dark.6": {
    "value": "var(--colors-color-palette-dark-6)",
    "variable": "var(--colors-color-palette-dark-6)"
  },
  "colors.colorPalette.dark.7": {
    "value": "var(--colors-color-palette-dark-7)",
    "variable": "var(--colors-color-palette-dark-7)"
  },
  "colors.colorPalette.dark.8": {
    "value": "var(--colors-color-palette-dark-8)",
    "variable": "var(--colors-color-palette-dark-8)"
  },
  "colors.colorPalette.dark.9": {
    "value": "var(--colors-color-palette-dark-9)",
    "variable": "var(--colors-color-palette-dark-9)"
  },
  "colors.colorPalette.dark.10": {
    "value": "var(--colors-color-palette-dark-10)",
    "variable": "var(--colors-color-palette-dark-10)"
  },
  "colors.colorPalette.dark.11": {
    "value": "var(--colors-color-palette-dark-11)",
    "variable": "var(--colors-color-palette-dark-11)"
  },
  "colors.colorPalette.dark.12": {
    "value": "var(--colors-color-palette-dark-12)",
    "variable": "var(--colors-color-palette-dark-12)"
  },
  "colors.colorPalette.dark.a1": {
    "value": "var(--colors-color-palette-dark-a1)",
    "variable": "var(--colors-color-palette-dark-a1)"
  },
  "colors.colorPalette.dark.a2": {
    "value": "var(--colors-color-palette-dark-a2)",
    "variable": "var(--colors-color-palette-dark-a2)"
  },
  "colors.colorPalette.dark.a3": {
    "value": "var(--colors-color-palette-dark-a3)",
    "variable": "var(--colors-color-palette-dark-a3)"
  },
  "colors.colorPalette.dark.a4": {
    "value": "var(--colors-color-palette-dark-a4)",
    "variable": "var(--colors-color-palette-dark-a4)"
  },
  "colors.colorPalette.dark.a5": {
    "value": "var(--colors-color-palette-dark-a5)",
    "variable": "var(--colors-color-palette-dark-a5)"
  },
  "colors.colorPalette.dark.a6": {
    "value": "var(--colors-color-palette-dark-a6)",
    "variable": "var(--colors-color-palette-dark-a6)"
  },
  "colors.colorPalette.dark.a7": {
    "value": "var(--colors-color-palette-dark-a7)",
    "variable": "var(--colors-color-palette-dark-a7)"
  },
  "colors.colorPalette.dark.a8": {
    "value": "var(--colors-color-palette-dark-a8)",
    "variable": "var(--colors-color-palette-dark-a8)"
  },
  "colors.colorPalette.dark.a9": {
    "value": "var(--colors-color-palette-dark-a9)",
    "variable": "var(--colors-color-palette-dark-a9)"
  },
  "colors.colorPalette.dark.a10": {
    "value": "var(--colors-color-palette-dark-a10)",
    "variable": "var(--colors-color-palette-dark-a10)"
  },
  "colors.colorPalette.dark.a11": {
    "value": "var(--colors-color-palette-dark-a11)",
    "variable": "var(--colors-color-palette-dark-a11)"
  },
  "colors.colorPalette.dark.a12": {
    "value": "var(--colors-color-palette-dark-a12)",
    "variable": "var(--colors-color-palette-dark-a12)"
  },
  "colors.colorPalette.primary": {
    "value": "var(--colors-color-palette-primary)",
    "variable": "var(--colors-color-palette-primary)"
  },
  "colors.colorPalette.orangeDarker": {
    "value": "var(--colors-color-palette-orange-darker)",
    "variable": "var(--colors-color-palette-orange-darker)"
  },
  "colors.colorPalette.orangeDark": {
    "value": "var(--colors-color-palette-orange-dark)",
    "variable": "var(--colors-color-palette-orange-dark)"
  },
  "colors.colorPalette.orange": {
    "value": "var(--colors-color-palette-orange)",
    "variable": "var(--colors-color-palette-orange)"
  },
  "colors.colorPalette.orangeLight": {
    "value": "var(--colors-color-palette-orange-light)",
    "variable": "var(--colors-color-palette-orange-light)"
  },
  "colors.colorPalette.orangeLighter": {
    "value": "var(--colors-color-palette-orange-lighter)",
    "variable": "var(--colors-color-palette-orange-lighter)"
  },
  "colors.colorPalette.fullBlack": {
    "value": "var(--colors-color-palette-full-black)",
    "variable": "var(--colors-color-palette-full-black)"
  },
  "colors.colorPalette.background": {
    "value": "var(--colors-color-palette-background)",
    "variable": "var(--colors-color-palette-background)"
  },
  "colors.colorPalette.lightBlack": {
    "value": "var(--colors-color-palette-light-black)",
    "variable": "var(--colors-color-palette-light-black)"
  },
  "colors.colorPalette.lighterBlack": {
    "value": "var(--colors-color-palette-lighter-black)",
    "variable": "var(--colors-color-palette-lighter-black)"
  },
  "colors.colorPalette.lv1": {
    "value": "var(--colors-color-palette-lv1)",
    "variable": "var(--colors-color-palette-lv1)"
  },
  "colors.colorPalette.lv2": {
    "value": "var(--colors-color-palette-lv2)",
    "variable": "var(--colors-color-palette-lv2)"
  },
  "colors.colorPalette.lv3": {
    "value": "var(--colors-color-palette-lv3)",
    "variable": "var(--colors-color-palette-lv3)"
  },
  "colors.colorPalette.lv4": {
    "value": "var(--colors-color-palette-lv4)",
    "variable": "var(--colors-color-palette-lv4)"
  },
  "colors.colorPalette.lv5": {
    "value": "var(--colors-color-palette-lv5)",
    "variable": "var(--colors-color-palette-lv5)"
  },
  "colors.colorPalette.lv6": {
    "value": "var(--colors-color-palette-lv6)",
    "variable": "var(--colors-color-palette-lv6)"
  },
  "colors.colorPalette.outline": {
    "value": "var(--colors-color-palette-outline)",
    "variable": "var(--colors-color-palette-outline)"
  },
  "colors.colorPalette.darkGary1": {
    "value": "var(--colors-color-palette-dark-gary1)",
    "variable": "var(--colors-color-palette-dark-gary1)"
  },
  "colors.colorPalette.darkGary2": {
    "value": "var(--colors-color-palette-dark-gary2)",
    "variable": "var(--colors-color-palette-dark-gary2)"
  },
  "colors.colorPalette.darkGary3": {
    "value": "var(--colors-color-palette-dark-gary3)",
    "variable": "var(--colors-color-palette-dark-gary3)"
  },
  "colors.colorPalette.darkGary4": {
    "value": "var(--colors-color-palette-dark-gary4)",
    "variable": "var(--colors-color-palette-dark-gary4)"
  },
  "colors.colorPalette.lightGrey3": {
    "value": "var(--colors-color-palette-light-grey3)",
    "variable": "var(--colors-color-palette-light-grey3)"
  },
  "colors.colorPalette.lightGrey2": {
    "value": "var(--colors-color-palette-light-grey2)",
    "variable": "var(--colors-color-palette-light-grey2)"
  },
  "colors.colorPalette.lightGrey1": {
    "value": "var(--colors-color-palette-light-grey1)",
    "variable": "var(--colors-color-palette-light-grey1)"
  },
  "colors.colorPalette.lightGrey4": {
    "value": "var(--colors-color-palette-light-grey4)",
    "variable": "var(--colors-color-palette-light-grey4)"
  },
  "colors.colorPalette.white": {
    "value": "var(--colors-color-palette-white)",
    "variable": "var(--colors-color-palette-white)"
  },
  "colors.colorPalette.priceUp": {
    "value": "var(--colors-color-palette-price-up)",
    "variable": "var(--colors-color-palette-price-up)"
  },
  "colors.colorPalette.priceUpEmphasized": {
    "value": "var(--colors-color-palette-price-up-emphasized)",
    "variable": "var(--colors-color-palette-price-up-emphasized)"
  },
  "colors.colorPalette.priceDown": {
    "value": "var(--colors-color-palette-price-down)",
    "variable": "var(--colors-color-palette-price-down)"
  },
  "colors.colorPalette.priceDownEmphasized": {
    "value": "var(--colors-color-palette-price-down-emphasized)",
    "variable": "var(--colors-color-palette-price-down-emphasized)"
  },
  "colors.colorPalette.priceUpBg": {
    "value": "var(--colors-color-palette-price-up-bg)",
    "variable": "var(--colors-color-palette-price-up-bg)"
  },
  "colors.colorPalette.priceDownBg": {
    "value": "var(--colors-color-palette-price-down-bg)",
    "variable": "var(--colors-color-palette-price-down-bg)"
  },
  "colors.colorPalette.priceUpLight": {
    "value": "var(--colors-color-palette-price-up-light)",
    "variable": "var(--colors-color-palette-price-up-light)"
  },
  "colors.colorPalette.priceDownLight": {
    "value": "var(--colors-color-palette-price-down-light)",
    "variable": "var(--colors-color-palette-price-down-light)"
  },
  "colors.colorPalette.errorLight": {
    "value": "var(--colors-color-palette-error-light)",
    "variable": "var(--colors-color-palette-error-light)"
  },
  "colors.colorPalette.error": {
    "value": "var(--colors-color-palette-error)",
    "variable": "var(--colors-color-palette-error)"
  },
  "colors.colorPalette.errorDark": {
    "value": "var(--colors-color-palette-error-dark)",
    "variable": "var(--colors-color-palette-error-dark)"
  },
  "colors.colorPalette.successLight": {
    "value": "var(--colors-color-palette-success-light)",
    "variable": "var(--colors-color-palette-success-light)"
  },
  "colors.colorPalette.success": {
    "value": "var(--colors-color-palette-success)",
    "variable": "var(--colors-color-palette-success)"
  },
  "colors.colorPalette.successDark": {
    "value": "var(--colors-color-palette-success-dark)",
    "variable": "var(--colors-color-palette-success-dark)"
  },
  "colors.colorPalette.systemLight": {
    "value": "var(--colors-color-palette-system-light)",
    "variable": "var(--colors-color-palette-system-light)"
  },
  "colors.colorPalette.system": {
    "value": "var(--colors-color-palette-system)",
    "variable": "var(--colors-color-palette-system)"
  },
  "colors.colorPalette.systemDark": {
    "value": "var(--colors-color-palette-system-dark)",
    "variable": "var(--colors-color-palette-system-dark)"
  },
  "colors.colorPalette.bg.canvas": {
    "value": "var(--colors-color-palette-bg-canvas)",
    "variable": "var(--colors-color-palette-bg-canvas)"
  },
  "colors.colorPalette.canvas": {
    "value": "var(--colors-color-palette-canvas)",
    "variable": "var(--colors-color-palette-canvas)"
  },
  "colors.colorPalette.bg.app": {
    "value": "var(--colors-color-palette-bg-app)",
    "variable": "var(--colors-color-palette-bg-app)"
  },
  "colors.colorPalette.app": {
    "value": "var(--colors-color-palette-app)",
    "variable": "var(--colors-color-palette-app)"
  },
  "colors.colorPalette.bg.panel": {
    "value": "var(--colors-color-palette-bg-panel)",
    "variable": "var(--colors-color-palette-bg-panel)"
  },
  "colors.colorPalette.panel": {
    "value": "var(--colors-color-palette-panel)",
    "variable": "var(--colors-color-palette-panel)"
  },
  "colors.colorPalette.bg.surface1": {
    "value": "var(--colors-color-palette-bg-surface1)",
    "variable": "var(--colors-color-palette-bg-surface1)"
  },
  "colors.colorPalette.surface1": {
    "value": "var(--colors-color-palette-surface1)",
    "variable": "var(--colors-color-palette-surface1)"
  },
  "colors.colorPalette.bg.surface2": {
    "value": "var(--colors-color-palette-bg-surface2)",
    "variable": "var(--colors-color-palette-bg-surface2)"
  },
  "colors.colorPalette.surface2": {
    "value": "var(--colors-color-palette-surface2)",
    "variable": "var(--colors-color-palette-surface2)"
  },
  "colors.colorPalette.bg.surface3": {
    "value": "var(--colors-color-palette-bg-surface3)",
    "variable": "var(--colors-color-palette-bg-surface3)"
  },
  "colors.colorPalette.surface3": {
    "value": "var(--colors-color-palette-surface3)",
    "variable": "var(--colors-color-palette-surface3)"
  },
  "colors.colorPalette.bg.hover": {
    "value": "var(--colors-color-palette-bg-hover)",
    "variable": "var(--colors-color-palette-bg-hover)"
  },
  "colors.colorPalette.hover": {
    "value": "var(--colors-color-palette-hover)",
    "variable": "var(--colors-color-palette-hover)"
  },
  "colors.colorPalette.border.hairline": {
    "value": "var(--colors-color-palette-border-hairline)",
    "variable": "var(--colors-color-palette-border-hairline)"
  },
  "colors.colorPalette.hairline": {
    "value": "var(--colors-color-palette-hairline)",
    "variable": "var(--colors-color-palette-hairline)"
  },
  "colors.colorPalette.border.default": {
    "value": "var(--colors-color-palette-border-default)",
    "variable": "var(--colors-color-palette-border-default)"
  },
  "colors.colorPalette.default": {
    "value": "var(--colors-color-palette-default)",
    "variable": "var(--colors-color-palette-default)"
  },
  "colors.colorPalette.border.strong": {
    "value": "var(--colors-color-palette-border-strong)",
    "variable": "var(--colors-color-palette-border-strong)"
  },
  "colors.colorPalette.strong": {
    "value": "var(--colors-color-palette-strong)",
    "variable": "var(--colors-color-palette-strong)"
  },
  "colors.colorPalette.border.focus": {
    "value": "var(--colors-color-palette-border-focus)",
    "variable": "var(--colors-color-palette-border-focus)"
  },
  "colors.colorPalette.focus": {
    "value": "var(--colors-color-palette-focus)",
    "variable": "var(--colors-color-palette-focus)"
  },
  "colors.colorPalette.text.primary": {
    "value": "var(--colors-color-palette-text-primary)",
    "variable": "var(--colors-color-palette-text-primary)"
  },
  "colors.colorPalette.text.secondary": {
    "value": "var(--colors-color-palette-text-secondary)",
    "variable": "var(--colors-color-palette-text-secondary)"
  },
  "colors.colorPalette.secondary": {
    "value": "var(--colors-color-palette-secondary)",
    "variable": "var(--colors-color-palette-secondary)"
  },
  "colors.colorPalette.text.muted": {
    "value": "var(--colors-color-palette-text-muted)",
    "variable": "var(--colors-color-palette-text-muted)"
  },
  "colors.colorPalette.muted": {
    "value": "var(--colors-color-palette-muted)",
    "variable": "var(--colors-color-palette-muted)"
  },
  "colors.colorPalette.text.subtle": {
    "value": "var(--colors-color-palette-text-subtle)",
    "variable": "var(--colors-color-palette-text-subtle)"
  },
  "colors.colorPalette.subtle": {
    "value": "var(--colors-color-palette-subtle)",
    "variable": "var(--colors-color-palette-subtle)"
  },
  "colors.colorPalette.text.disabled": {
    "value": "var(--colors-color-palette-text-disabled)",
    "variable": "var(--colors-color-palette-text-disabled)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--colors-color-palette-disabled)",
    "variable": "var(--colors-color-palette-disabled)"
  },
  "colors.colorPalette.text.onAccent": {
    "value": "var(--colors-color-palette-text-on-accent)",
    "variable": "var(--colors-color-palette-text-on-accent)"
  },
  "colors.colorPalette.onAccent": {
    "value": "var(--colors-color-palette-on-accent)",
    "variable": "var(--colors-color-palette-on-accent)"
  },
  "colors.colorPalette.long.default": {
    "value": "var(--colors-color-palette-long-default)",
    "variable": "var(--colors-color-palette-long-default)"
  },
  "colors.colorPalette.long.strong": {
    "value": "var(--colors-color-palette-long-strong)",
    "variable": "var(--colors-color-palette-long-strong)"
  },
  "colors.colorPalette.long.dim": {
    "value": "var(--colors-color-palette-long-dim)",
    "variable": "var(--colors-color-palette-long-dim)"
  },
  "colors.colorPalette.dim": {
    "value": "var(--colors-color-palette-dim)",
    "variable": "var(--colors-color-palette-dim)"
  },
  "colors.colorPalette.long.border": {
    "value": "var(--colors-color-palette-long-border)",
    "variable": "var(--colors-color-palette-long-border)"
  },
  "colors.colorPalette.border": {
    "value": "var(--colors-color-palette-border)",
    "variable": "var(--colors-color-palette-border)"
  },
  "colors.colorPalette.long.deep": {
    "value": "var(--colors-color-palette-long-deep)",
    "variable": "var(--colors-color-palette-long-deep)"
  },
  "colors.colorPalette.deep": {
    "value": "var(--colors-color-palette-deep)",
    "variable": "var(--colors-color-palette-deep)"
  },
  "colors.colorPalette.short.default": {
    "value": "var(--colors-color-palette-short-default)",
    "variable": "var(--colors-color-palette-short-default)"
  },
  "colors.colorPalette.short.strong": {
    "value": "var(--colors-color-palette-short-strong)",
    "variable": "var(--colors-color-palette-short-strong)"
  },
  "colors.colorPalette.short.dim": {
    "value": "var(--colors-color-palette-short-dim)",
    "variable": "var(--colors-color-palette-short-dim)"
  },
  "colors.colorPalette.short.border": {
    "value": "var(--colors-color-palette-short-border)",
    "variable": "var(--colors-color-palette-short-border)"
  },
  "colors.colorPalette.short.deep": {
    "value": "var(--colors-color-palette-short-deep)",
    "variable": "var(--colors-color-palette-short-deep)"
  },
  "colors.colorPalette.info": {
    "value": "var(--colors-color-palette-info)",
    "variable": "var(--colors-color-palette-info)"
  },
  "colors.colorPalette.warning": {
    "value": "var(--colors-color-palette-warning)",
    "variable": "var(--colors-color-palette-warning)"
  },
  "colors.colorPalette.warningDim": {
    "value": "var(--colors-color-palette-warning-dim)",
    "variable": "var(--colors-color-palette-warning-dim)"
  },
  "colors.colorPalette.warningBorder": {
    "value": "var(--colors-color-palette-warning-border)",
    "variable": "var(--colors-color-palette-warning-border)"
  },
  "colors.colorPalette.tokLv": {
    "value": "var(--colors-color-palette-tok-lv)",
    "variable": "var(--colors-color-palette-tok-lv)"
  },
  "colors.colorPalette.tokLvusd": {
    "value": "var(--colors-color-palette-tok-lvusd)",
    "variable": "var(--colors-color-palette-tok-lvusd)"
  },
  "colors.colorPalette.tokLvmon": {
    "value": "var(--colors-color-palette-tok-lvmon)",
    "variable": "var(--colors-color-palette-tok-lvmon)"
  },
  "colors.colorPalette.vipGold": {
    "value": "var(--colors-color-palette-vip-gold)",
    "variable": "var(--colors-color-palette-vip-gold)"
  },
  "colors.colorPalette.vipGoldDim": {
    "value": "var(--colors-color-palette-vip-gold-dim)",
    "variable": "var(--colors-color-palette-vip-gold-dim)"
  },
  "colors.colorPalette.vipGoldBorder": {
    "value": "var(--colors-color-palette-vip-gold-border)",
    "variable": "var(--colors-color-palette-vip-gold-border)"
  },
  "colors.colorPalette.gridLine": {
    "value": "var(--colors-color-palette-grid-line)",
    "variable": "var(--colors-color-palette-grid-line)"
  },
  "colors.colorPalette.G.01": {
    "value": "var(--colors-color-palette--g-01)",
    "variable": "var(--colors-color-palette--g-01)"
  },
  "colors.colorPalette.01": {
    "value": "var(--colors-color-palette-01)",
    "variable": "var(--colors-color-palette-01)"
  },
  "colors.colorPalette.G.leaderBoardGradient": {
    "value": "var(--colors-color-palette--g-leader-board-gradient)",
    "variable": "var(--colors-color-palette--g-leader-board-gradient)"
  },
  "colors.colorPalette.leaderBoardGradient": {
    "value": "var(--colors-color-palette-leader-board-gradient)",
    "variable": "var(--colors-color-palette-leader-board-gradient)"
  },
  "colors.colorPalette.unCategorized.green": {
    "value": "var(--colors-color-palette-un-categorized-green)",
    "variable": "var(--colors-color-palette-un-categorized-green)"
  },
  "colors.colorPalette.green": {
    "value": "var(--colors-color-palette-green)",
    "variable": "var(--colors-color-palette-green)"
  },
  "colors.colorPalette.tooltip": {
    "value": "var(--colors-color-palette-tooltip)",
    "variable": "var(--colors-color-palette-tooltip)"
  },
  "colors.colorPalette.banner": {
    "value": "var(--colors-color-palette-banner)",
    "variable": "var(--colors-color-palette-banner)"
  },
  "colors.colorPalette.emphasized": {
    "value": "var(--colors-color-palette-emphasized)",
    "variable": "var(--colors-color-palette-emphasized)"
  },
  "colors.colorPalette.fg": {
    "value": "var(--colors-color-palette-fg)",
    "variable": "var(--colors-color-palette-fg)"
  },
  "colors.colorPalette.text": {
    "value": "var(--colors-color-palette-text)",
    "variable": "var(--colors-color-palette-text)"
  },
  "colors.colorPalette.gold": {
    "value": "var(--colors-color-palette-gold)",
    "variable": "var(--colors-color-palette-gold)"
  },
  "colors.colorPalette.silver": {
    "value": "var(--colors-color-palette-silver)",
    "variable": "var(--colors-color-palette-silver)"
  },
  "colors.colorPalette.bronze": {
    "value": "var(--colors-color-palette-bronze)",
    "variable": "var(--colors-color-palette-bronze)"
  },
  "colors.colorPalette.subtitle": {
    "value": "var(--colors-color-palette-subtitle)",
    "variable": "var(--colors-color-palette-subtitle)"
  },
  "colors.colorPalette.bg": {
    "value": "var(--colors-color-palette-bg)",
    "variable": "var(--colors-color-palette-bg)"
  },
  "colors.colorPalette.brown": {
    "value": "var(--colors-color-palette-brown)",
    "variable": "var(--colors-color-palette-brown)"
  },
  "colors.colorPalette.descBg": {
    "value": "var(--colors-color-palette-desc-bg)",
    "variable": "var(--colors-color-palette-desc-bg)"
  },
  "colors.colorPalette.descBorder": {
    "value": "var(--colors-color-palette-desc-border)",
    "variable": "var(--colors-color-palette-desc-border)"
  },
  "colors.colorPalette.titleGreyColor": {
    "value": "var(--colors-color-palette-title-grey-color)",
    "variable": "var(--colors-color-palette-title-grey-color)"
  },
  "colors.colorPalette.countDownBorderColor": {
    "value": "var(--colors-color-palette-count-down-border-color)",
    "variable": "var(--colors-color-palette-count-down-border-color)"
  },
  "colors.colorPalette.countDownBgColor": {
    "value": "var(--colors-color-palette-count-down-bg-color)",
    "variable": "var(--colors-color-palette-count-down-bg-color)"
  },
  "colors.colorPalette.countDownDescItemColor": {
    "value": "var(--colors-color-palette-count-down-desc-item-color)",
    "variable": "var(--colors-color-palette-count-down-desc-item-color)"
  },
  "colors.colorPalette.countDownTextColor": {
    "value": "var(--colors-color-palette-count-down-text-color)",
    "variable": "var(--colors-color-palette-count-down-text-color)"
  },
  "colors.colorPalette.switchThumb": {
    "value": "var(--colors-color-palette-switch-thumb)",
    "variable": "var(--colors-color-palette-switch-thumb)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar